import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors,
  FormControl,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from "@angular/material/dialog";
import { Citizenship } from "src/app/core/models/citizenship";
import { AddressService } from "src/app/core/services/address.service";
import { CitizenshipService } from "src/app/core/services/citizenship.service";
import { OccupationService } from "src/app/core/services/occupations.service";
import { UserService } from "src/app/core/services/user.service";
import { ForgotPasswordComponent } from "src/app/home/home-components/forgot-password/forgot-password.component";
import Swal from "sweetalert2";

import {
  Observable,
  Subject,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  find,
  last,
  map,
  of,
  startWith,
  switchMap,
} from "rxjs";
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import heic2any from "heic2any";
import {
  Gallery,
  GalleryItem,
  ImageItem,
  ThumbnailsPosition,
  ImageSize,
} from "@ngx-gallery/core";
import { error } from "console";
import { EligibilityProfessionalLicense } from "src/app/core/models/eligibilityProfessionalLicense";
import { TechnicalTraining } from "src/app/core/models/technicalTrainings";
import { WorkExpercience } from "src/app/core/models/workExpercience";
import { TechnicalTrainingService } from "src/app/core/services/technicalTrainins.service";
import { EditTechnicalTrainingComponent } from "src/app/dashboard/dashboard-components/new-application/components/peso-form/edit-technical-training/edit-technical-training.component";
import { AddTrainingComponent } from "src/app/dashboard/dashboard-components/new-application/components/peso-form/add-training/add-training.component";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { AddLicenseComponent } from "src/app/dashboard/dashboard-components/new-application/components/peso-form/add-license/add-license.component";
import { LicenseService } from "src/app/core/services/license.service";
import { EditLicenseComponent } from "src/app/dashboard/dashboard-components/new-application/components/peso-form/edit-license/edit-license.component";
import { AddWorkExpercienceComponent } from "src/app/dashboard/dashboard-components/new-application/components/peso-form/add-work-expercience/add-work-expercience.component";
import { WorkHistoryService } from "src/app/core/services/work-expercience.service";
import { EditWorkExpercienceComponent } from "src/app/dashboard/dashboard-components/new-application/components/peso-form/edit-work-expercience/edit-work-expercience.component";
import { EducationalBackgroudService } from "src/app/core/services/educationalBackground.service";
import { UnderGraduate } from "src/app/core/models/undergraduate";
import { PostGraduate } from "src/app/core/models/postGraduate";
import { AddItemUndergraduateComponent } from "src/app/dashboard/dashboard-components/applicant-profiling/compponents/add-item-undergraduate/add-item-undergraduate.component";
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { SkillsWithoutCertificateService } from "src/app/core/services/skillsWithoutCertificate.service";
import { MatChipInputEvent } from "@angular/material/chips";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  NativeDateAdapter,
} from "@angular/material/core";
import { MatDatepicker } from "@angular/material/datepicker";
import { Graduate } from "src/app/core/models/graduate";
import { AddItemGraduateComponent } from "src/app/dashboard/dashboard-components/applicant-profiling/compponents/add-item-graduate/add-item-graduate.component";
import { AddItemPostGraduateComponent } from "src/app/dashboard/dashboard-components/applicant-profiling/compponents/add-item-post-graduate/add-item-post-graduate.component";
import { EditGraduateComponent } from "src/app/dashboard/dashboard-components/applicant-profiling/compponents/edit-graduate/edit-graduate.component";
import { EditPostGraduateComponent } from "src/app/dashboard/dashboard-components/applicant-profiling/compponents/edit-post-graduate/edit-post-graduate.component";
import { EditUndergraduateComponent } from "src/app/dashboard/dashboard-components/applicant-profiling/compponents/edit-undergraduate/edit-undergraduate.component";

class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date): string {
    return `${date.getFullYear()}`;
  }
}

@Component({
  selector: "app-more-info-modal",
  templateUrl: "./more-info-modal.component.html",
  styleUrls: ["./more-info-modal.component.css"],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: { dateInput: "YYYY" },
        display: {
          dateInput: "YYYY",
          monthYearLabel: "YYYY",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "YYYY",
        },
      },
    },
  ],
})
export class MoreInfoModalComponent implements OnInit, AfterViewInit {
  @Input() applicantDetailsFromEvaluator;

  currentDate: Date;

  // Min Date property
  minDate: Date;
  maxDate: Date;

  showImageIcon = false;
  selectedNav = "profile";
  birthDateMask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

  errorMessageBirthday: string;

  @ViewChild("fileInputID") elID: ElementRef;
  imageUrlID: any;
  imageName: any;
  imageBinary: any;
  editFileID: boolean = true;
  removeUploadID: boolean = false;

  @ViewChild("fileInputSelfieID") elSelfieID: ElementRef;
  imageUrlSelfieID: any;
  editFileSelfieID: boolean = true;
  removeUploadSelfieID: boolean = false;

  genderSelected: any;
  civilStatusSelected: any;
  religionSelected: any;

  panelOpenState = false;

  permanentAddressStatus;

  // Edit Mode
  // editMode:boolean = false;
  isPersonalDetailsEditMode: boolean = false;
  isAddressDetailsEditMode: boolean = false;
  isEducationalDetailsEditMode: boolean = false;
  isIdentificationDetailsMode = false;
  isChangePasswordMode = false;

  //disableNavigation
  disableNavigation: boolean = false;

  // View Forms Group
  viewPersonalDetailsGroup: FormGroup;
  viewAddressDetailsGroup: FormGroup;
  viewEducationalDetailsGroup: FormGroup;

  // NgModel Address
  isAddressEqualSelected: any;

  // Edit Forms Group
  personalDetailsGroup: FormGroup;
  addressDetailsGroup: FormGroup;
  educationalBackgroundDetailsGroup: FormGroup;
  technicalVocationalDetailsGroup: FormGroup;
  eligibilityDetailsGroup: FormGroup;
  identificationDetailsGroup: FormGroup;
  changePasswordGroup: FormGroup;

  //Present Address
  regions = [];
  provinces = [];
  citiesMunicipalities = [];
  barangaysBaguio = [];
  selectedRegion: any;
  selectedProvince: any;
  selectedCityMunicipality: any;
  selectedBarangayBaguio: any;
  presentBarangayID: any;

  // Permenant Address
  regionsPermanent = [];
  provincesPermanent = [];
  citiesMunicipalitiesPermanent = [];
  barangaysBaguioPermanent = [];
  selectedRegionPermanent: any;
  selectedProvincePermanent: any;
  selectedCityMunicipalityPermanent: any;
  selectedBarangayBaguioPermanent: any;
  permanentBarangayID: any;

  // Citizenship
  allCitizenships: Citizenship[];
  filteredCitizenships: Observable<any[]>;
  notFoundCitzenship: boolean = false;

  // Filtered Religion
  filteredReligions: any;

  // Identiication
  idNumberText: any;
  idTypeText: any;
  finalPassport: any;
  finalFront: any;
  finalBack: any;
  finalSeflfie: any;
  isFinalPassportConverted: any;
  isFinalSeflieConverted: any;
  updatedUserData: any;

  submitted = false;

  yes = false;
  no = false;

  addressStatusSelected: any;

  currentPassword = true;
  newPassword = true;
  confirmPassword = true;

  // user data
  userData: any;

  // user education

  // ID dropdown
  selectedIDType: any;
  selectedPhotoName: File;
  selectedFileFront: File;
  selectedIDBack: File;
  passportConverted: boolean = false;
  selfieConverted: boolean = false;

  existingFileBackPhoto: any;
  idPhotoName: any;
  idImageIDFrontPath: any;
  idImageIDBackPath: any;
  idSeflieImagePath: any;
  idImagePath: any;
  idImagePathFront: any;
  idImagePathBack: any;
  selectedFile: File;
  existingFileName: any;
  idPhotoPreview: string;
  selectedID: File;
  idPhotoNameDraft: any;
  idPhotoNameFrontDraft: any;
  idPhotoNameBackDraft: any;
  selfieWithIdPhotoNameDraft: any;
  existingSelfieFileName: any;
  idPassortLength: number = 0;
  idFrontLength: number = 0;
  idBackLength: number = 0;
  idSelfieLength: number = 0;

  genders: any = [
    { id: "M", name: "Male" },
    { id: "F", name: "Female" },
  ];

  disabilityStatuses: any = [
    { id: 0, name: "No Disability" },
    { id: 1, name: "Visual" },
    { id: 2, name: "Speech" },
    { id: 3, name: "Psychosocial" },
    { id: 4, name: "Hearing" },
    { id: 5, name: "Physical" },
  ];

  selectedDisability: any;

  // genderTypes
  userGender: any;
  presentBarangayText: any;

  // empployment
  employmentOthersText: any;

  // contactNumber Prefix
  displayedContactNumber: string = "(+63)";

  items: GalleryItem[];
  itemsSelfie: GalleryItem[];

  // idPhotoPreview:any;
  selfieIDPreview: any;
  idImagePathFrontPath: any;
  idImagePathBackPath: any;
  identificationChanged: boolean = false;
  originalIDType: number;

  // Check ID
  patternInput: boolean = false;

  // ngModels
  educationSelected: any;
  secondarySelectedYes: any;
  didAttendSeniorHighYes: any;
  selectedStrandYes: any;
  tertiarySelectedYes: any;

  userEducation: any;

  selectedIsStillStudying: any;
  highesEducationAttainment: any;

  elementaryYear: any;
  highSchoolYear: any;

  //Elementary Levels
  elementaryLevels: any = [
    { id: 0, name: "Grade 1" },
    { id: 1, name: "Grade 2" },
    { id: 2, name: "Grade 3" },
    { id: 3, name: "Grade 4" },
    { id: 4, name: "Grade 5" },
    { id: 5, name: "Grade 6" },
  ];

  // Secondary Levels
  secondaryLevels: any = [
    { id: 0, name: "Grade 7 (1st year - High School)" },
    { id: 1, name: "Grade 8 (2nd year - High School)" },
    { id: 2, name: "Grade 9 (3rd year - High School)" },
    { id: 3, name: "Grade 10 (4th year - High School)" },
  ];

  // k12Levels
  k12Levels: any = [
    { id: 0, name: "Grade 11" },
    { id: 1, name: "Grade 12" },
  ];

  // Senior High School Strand
  k12Strands: any = [
    { id: 0, name: "Business, Accountancy, Management (BAM)" },
    { id: 1, name: "Humanities, Education, Social Sciences (HESS)" },
    { id: 2, name: "Science, Technology, Engineering, Mathematics (STEM)" },
    { id: 3, name: "General Academic Strand (GAS)" },
  ];

  @ViewChild("UndergraduateTable") tableUndergraduate: MatTable<UnderGraduate>;
  @ViewChild("graduateTable") tableGraduate: MatTable<Graduate>;
  @ViewChild("postGraduateTable") tablePostGraduate: MatTable<PostGraduate>;
  @ViewChild("technicalTrainingTable")
  tabletechnical: MatTable<TechnicalTraining>;
  @ViewChild("eligibilityLicenseTable")
  tableEligibilityLicense: MatTable<EligibilityProfessionalLicense>;
  @ViewChild("workHistoryTable") tableWorkHistory: MatTable<WorkExpercience>;

  elementarySelectedYes: any;

  errorMessagek12: string = "";
  showMessagek12: boolean = false;

  displayedColumns: string[] = ["add"];

  //Undergraduate Table

  dataSourceUndergraduate: any = [];
  displayedColumnsUndergraduate: string[] = [
    "id",
    "school",
    "course",
    "yearAttended",
    "actions",
  ];

  // Graduate Table
  dataSourceGraduate: any = [];
  displayedColumnsGraduate: string[] = [
    "id",
    "school",
    "program",
    "major",
    "fieldOfStudy",
    "course",
    "yearAttended",
    "actions",
  ];

  // Post Graduate Table
  dataSourcePostGraduate: any = [];
  displayedColumnsPostGraduate: string[] = [
    "id",
    "school",
    "program",
    "major",
    "dissertationTitle",
    "fieldOfStudy",
    "researchInterest",
    "publications",
    "yearAttended",
    "actions",
  ];

  dataSourceTechnicalTrainings: any = [];
  displayedColumnsTechnicalTrainings: string[] = [
    "id",
    "trainingCourse",
    "hoursOfTraining",
    "trainingInstitution",
    "certificates",
    "skillsAcquired",
    "actions",
  ];

  //Eligibility/Professional License
  dataSoruceEligibilityProfessioalLicense: any = [];
  displayedColumnsEligibilityProfessionalLicense: string[] = [
    "id",
    "licenseType",
    "eligibilityLevel",
    "dateTaken",
    "prcLicense",
    "validUntil",
    "actions",
  ];

  dataSourceWorkExperience: any = [];

  // WORKEXPERCIENCE_DATA: WorkExpercience[] = [];

  // dataSoruceWorkExpercience = this.WORKEXPERCIENCE_DATA;

  displayedColumnsWorkExpercience: string[] = [
    "id",
    "companyName",
    "country",
    "cityMunicipality",
    "startOfContractDate",
    "endOfContractData",
    "occupation",
    "employmentType",
    "actions",
  ];

  constructor(
    public dialogRef: MatDialogRef<MoreInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private addressService: AddressService,
    private occupationService: OccupationService,
    private userService: UserService,
    private citizenshipService: CitizenshipService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private gallery: Gallery,
    private educationalBackgroundService: EducationalBackgroudService,
    private technicalTrainingService: TechnicalTrainingService,
    private licenseService: LicenseService,
    private workHistoryService: WorkHistoryService,
    private skillsWithoutCertificateService: SkillsWithoutCertificateService
  ) {
    const axios = require("axios");
    const moment = require("moment");

    axios
      .get("https://worldtimeapi.org/api/timezone/Asia/Manila")
      .then((response) => {
        const currentDatetime = moment(response.data.datetime);
        const currentYear = currentDatetime.year();

        // Calculate minDate and maxDate based on the API response
        this.currentDate = currentDatetime.date();
        this.minDate = new Date(currentYear - 150, 0, 1); // 20 years ago
        this.maxDate = new Date(currentYear + 0, 11, 31); // 1 year in the future
      })
      .catch((error) => {
        console.error("Error fetching API:", error);
      });
  }
  ngAfterViewInit(): void {
    this.patchValueViewEducationalBackground();
  }

  genderTypes: any = [
    { id: "M", name: "Male" },
    { id: "F", name: "Female" },
  ];

  civilStatusTypes: any = [
    { id: 1, name: "Single" },
    { id: 2, name: "Married" },
    { id: 3, name: "Legally Separated/Annulled" },
    { id: 4, name: "Widowed" },
  ];

  suffixes: any = [
    { id: 8, name: "N/A" },
    { id: 1, name: "Jr." },
    { id: 2, name: "Sr." },
    { id: 3, name: "III" },
    { id: 4, name: "IV" },
    { id: 5, name: "V" },
    { id: 6, name: "VI" },
    { id: 7, name: "Mr" },
    { id: 8, name: "Mrs" },
  ];

  cardHolderTypes: any = [
    { id: 1, name: "Food Handler" },
    { id: 2, name: "Non-Food Handler" },
  ];

  idTypes = [
    { id: 1, label: "Passport" },
    {
      id: 2,
      label: "Driver's License",
    },
    { id: 3, label: "PRC ID" },
    { id: 4, label: "School ID" },
    { id: 5, label: "SSS/UMID" },
    // { id: 6, label: "Senior Citizen ID" },
    // { id: 7, label: "PWD" },
    { id: 6, label: "PhilHealth" },
    { id: 7, label: "PAG-IBIG" },
    { id: 8, label: "TIN" },
    { id: 9, label: "PhilSys" },
  ];

  religions: any = [
    { name: "Aglipayan" },
    { name: "Bible Baptist Church" },
    { name: "Evangelicals" },
    { name: "Iglesia ni Cristo" },
    { name: "Islam" },
    { name: "Jehovah's Witnesses" },
    { name: "Non-Roman Catholic and Protestant (NCCP)" },
    { name: "Roman Catholic" },
    { name: "Seventh-day Adventist" },
    { name: "United Church of the Christ in the Philippines" },
    { name: "Others" },
  ];

  educationSingle: any;

  highestEducation: any;

  otherSkills: string[] = [
    "Auto Mechanic",
    "Beautician",
    "Carpentry Work",
    "Computer Literate",
    "Domestic Chore",
    "Drivers",
    "Electrician",
    "Embroidery",
    "Gardening",
    "Masonry",
    "Painter/Artist",
    "Painter Jobs",
    "Photography",
    "Plumbing",
    "Sewing Dresses",
    "Stenography",
    "Tailoring",
  ];

  // Mat Chips Demo
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;
  fruits: string[] = [];
  selectedSkills: string[] = [];
  @ViewChild("fruitInput", { static: false })
  fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild("auto", { static: false }) matAutocomplete: MatAutocomplete;

  ngOnInit(): void {
    this.userData = this.data;

    // Get all undergraduate
    this.getAllUndergraduates();

    // Get all graduate
    this.getAllGraduates();

    // Get all post graduate
    this.getAllPostGraduates();

    // Get all trainings
    this.getAllTrainings();

    // Get all eligibility
    this.getAllLicenses();

    // Get all work history
    this.getAllWorkHistory();

    // Get all skilss
    this.getSkills();

    this.personalDetailsGroup = this.fb.group({
      firstName: ["", [Validators.required, this.notEmptyString]],
      middleName: [""],
      lastName: ["", [Validators.required, this.notEmptyString]],
      suffix: ["", Validators.required],
      heightFt: ["", [Validators.required, Validators.pattern(/^[0-9.\s]*$/)]],
      heightInches: [
        "",
        [Validators.required, Validators.pattern(/^[0-9.\s]*$/)],
      ],

      weight: [
        "",
        [
          Validators.required,
          Validators.min(0),
          Validators.max(400),
          this.maxValueValidator.bind(this),
        ],
      ],
      gender: ["", Validators.required],
      civilStatus: ["", Validators.required],
      religion: [
        "",
        [
          Validators.required,
          this.validateReligion.bind(this),
          this.notEmptyString,
        ],
      ],
      othersReligion: [""],
      citizenship: [
        "",
        [
          Validators.required,
          this.validateCitizenship.bind(this),
          this.notEmptyString,
        ],
      ],
      birthDate: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/((19|20)\d\d)$/
          ),
          this.validateAge,
        ],
      ],
      birthPlace: [
        "",
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z ]+$/),
          this.notEmptyString,
        ],
      ],
      tin: [""],
      contactNumber: [
        "",
        [
          Validators.required,
          Validators.pattern(/^\(\+63\)\d{10}$/),
          this.contactNumberPrefix.bind(this),
        ],
      ],
      disabilityStatus: ["", Validators.required],
    });

    this.allCitizenships = this.citizenshipService.getAllCitizenships();

    this.filteredCitizenships =
      this.personalDetailsGroup.controls.citizenship.valueChanges.pipe(
        startWith(""),
        map((value) => this._filterCitizenship(value))
      );

    this.filteredReligions =
      this.personalDetailsGroup.controls.religion.valueChanges.pipe(
        startWith(""),
        map((value) => this._filterReligion(value))
      );

    this.patchValuePersonalDetails();

    this.viewPersonalDetailsGroup = this.fb.group({
      firstName: [{ value: "", disabled: true }],
      middleName: [{ value: "", disabled: true }],
      lastName: [{ value: "", disabled: true }],
      suffix: [{ value: "", disabled: true }],
      heightFt: [{ value: "", disabled: true }],
      heightInches: [{ value: "", disabled: true }],
      weight: [{ value: "", disabled: true }],
      civilStatus: [{ value: "", disabled: true }],
      citizenship: [{ value: "", disabled: true }],
      gender: [{ value: "", disabled: true }],
      religion: [{ value: "", disabled: true }],
      othersReligion: [{ value: "", disabled: true }],
      birthDate: [{ value: "", disabled: true }],
      birthPlace: [{ value: "", disabled: true }],
      tin: [{ value: "", disabled: true }],
      disabilityStatus: [{ value: "", disabled: true }],
      contactNumber: [{ value: "", disabled: true }],
    });

    this.patchValueViewPersonalDetails();

    this.addressDetailsGroup = this.fb.group({
      presentRegionId: ["", Validators.required],
      presentProvinceId: ["", Validators.required],
      presentCityId: ["", Validators.required],
      presentStreetName: ["", [Validators.required, this.notEmptyString]],
      presentBarangayId: [""],
      presentBarangay: ["", [Validators.required, this.notEmptyString]],
      isAddressPresentEqualToPermanent: ["", Validators.required],
      permanentRegionId: [""],
      permanentProvinceId: [""],
      permanentCityId: [""],
      permanentStreetName: [""],
      permanentBarangayId: [""],
      permanentBarangay: [""],
    });

    this.patchValueAddressDetails();

    this.viewAddressDetailsGroup = this.fb.group({
      presentRegionId: [{ value: "", disabled: true }],
      presentProvinceId: [{ value: "", disabled: true }],
      presentCityId: [{ value: "", disabled: true }],
      presentStreetName: [{ value: "", disabled: true }],
      presentBarangayId: [{ value: "", disabled: true }],
      presentBarangay: [{ value: "", disabled: true }],
      isAddressPresentEqualToPermanent: [
        {
          value: "",
          disabled: true,
        },
      ],
      permanentRegionId: [{ value: "", disabled: true }],
      permanentProvinceId: [{ value: "", disabled: true }],
      permanentCityId: [{ value: "", disabled: true }],
      permanentStreetName: [{ value: "", disabled: true }],
      permanentBarangayId: [{ value: "", disabled: true }],
      permanentBarangay: [{ value: "", disabled: true }],
    });

    this.patchValueViewAddressDetails();

    this.educationalBackgroundDetailsGroup = this.fb.group({
      isStillStudying: [""],
      highestEducationLevel: [""],
      elementarySchool: [""],
      elementaryLevelReached: [""],
      elementaryYearAttended: [""],
      highSchool: [""],
      highSchoolLevelReached: [""],
      highSchoolYearAttended: [""],
      isAttendedSeniorHigh: [""],
      seniorHighSchool: [""],
      seniorHighSchoolStrands: [""],
      seniorHighSchoolLevelReached: [""],
      seniorHighSchoolYearAttended: [""],
      tertiaryStatus: [""],
      collegeCourse: [""],
      collegeYearGraduated: [""],
      collegeLevelReached: [""],
      collegeLastAttended: [""],
    });

    this.patchValueEducationalDetails();

    this.viewEducationalDetailsGroup = this.fb.group({
      isStillStudying: [{ value: "", disabled: true }],
      highestEducationLevel: [{ value: "", disabled: true }],
      elementarySchool: [{ value: "", disabled: true }],
      elementaryLevelReached: [{ value: "", disabled: true }],
      elementaryYearAttended: [{ value: "", disabled: true }],
      highSchool: [{ value: "", disabled: true }],
      highSchoolLevelReached: [{ value: "", disabled: true }],
      highSchoolYearAttended: [{ value: "", disabled: true }],
      isAttendedSeniorHigh: [{ value: "", disabled: true }],
      seniorHighSchool: [{ value: "", disabled: true }],
      seniorHighSchoolStrands: [{ value: "", disabled: true }],
      seniorHighSchoolLevelReached: [{ value: "", disabled: true }],
      seniorHighSchoolYearAttended: [{ value: "", disabled: true }],
      tertiaryStatus: [{ value: "", disabled: true }],
      collegeCourse: [{ value: "", disabled: true }],
      collegeYearGraduated: [{ value: "", disabled: true }],
      collegeLevelReached: [{ value: "", disabled: true }],
      collegeLastAttended: [{ value: "", disabled: true }],
    });

    this.patchValueViewEducationalBackground();

    this.identificationDetailsGroup = this.fb.group({
      dropdown: ["", Validators.required],
      pattern: ["", Validators.required],
    });

    this.patchValueIdentification();

    this.changePasswordGroup = this.fb.group({
      currentPassword: [""],
      newPassword: [""],
      confirmPassword: [""],
    });

    this.changePasswordGroup = this.fb.group({
      currentPassword: ["", Validators.required],
      newPassword: ["", Validators.required],
      confirmPassword: ["", Validators.required],
    });

    this.addressService.getBarangaysBaguio().subscribe((response: any) => {
      this.barangaysBaguio = response.data;
    });

    this.addressService.getRegions().subscribe((response) => {
      this.regions = response;
    });

    this.addressService.getRegions().subscribe((response) => {
      this.regionsPermanent = response;
    });

    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) =>
        fruit ? this._filterfrutis(fruit) : this.otherSkills.slice()
      )
    );
  }

  // Listen to address status change
  onPermanentAddressStatusChange(event: any) {
    const addressStatus = event.value;

    this.addressDetailsGroup.patchValue({
      permanentBarangay: "",
      permanentStreetName: "",
    });

    this.selectedRegionPermanent = null;
    this.selectedProvincePermanent = null;
    this.selectedCityMunicipalityPermanent = null;
    this.selectedBarangayBaguioPermanent = null;

    // Clear all validators initially
    this.addressDetailsGroup.controls.permanentRegionId.clearValidators();
    this.addressDetailsGroup.controls.permanentProvinceId.clearValidators();
    this.addressDetailsGroup.controls.permanentCityId.clearValidators();
    this.addressDetailsGroup.controls.permanentBarangay.clearValidators();
    this.addressDetailsGroup.controls.permanentStreetName.clearValidators();

    if (addressStatus === 2) {
      // Set validators if addressStatus is 2
      this.addressDetailsGroup.controls.permanentRegionId.setValidators(
        Validators.required
      );
      this.addressDetailsGroup.controls.permanentProvinceId.setValidators(
        Validators.required
      );
      this.addressDetailsGroup.controls.permanentCityId.setValidators(
        Validators.required
      );
      this.addressDetailsGroup.controls.permanentBarangay.setValidators([
        Validators.required,
        this.notEmptyString,
      ]);
      this.addressDetailsGroup.controls.permanentStreetName.setValidators([
        Validators.required,
        this.notEmptyString,
      ]);
    } else {
      this.addressDetailsGroup.controls.permanentRegionId.clearValidators();
      this.addressDetailsGroup.controls.permanentProvinceId.clearValidators();
      this.addressDetailsGroup.controls.permanentCityId.clearValidators();
      this.addressDetailsGroup.controls.permanentBarangay.clearValidators();
      this.addressDetailsGroup.controls.permanentStreetName.clearValidators();
    }

    // Update validity of all controls
    this.addressDetailsGroup.controls.permanentRegionId.updateValueAndValidity();
    this.addressDetailsGroup.controls.permanentProvinceId.updateValueAndValidity();
    this.addressDetailsGroup.controls.permanentCityId.updateValueAndValidity();
    this.addressDetailsGroup.controls.permanentBarangay.updateValueAndValidity();
    this.addressDetailsGroup.controls.permanentStreetName.updateValueAndValidity();
  }

  // Radio button select
  onk12RadioButtonsSelect() {
    this.clearAllValidatorsEducational();

    this.updateValidatorsEducational();
  }

  // Highhest Educational Status Selected
  onEducationStatusChange() {
    const selectedEducation = this.highesEducationAttainment;

    this.clearAllValidatorsEducational();

    switch (selectedEducation) {
      case 0:
        this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValue(
          null
        );

        break;

      case 1:
        this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
          [Validators.required]
        );
        this.educationalBackgroundDetailsGroup.controls.elementaryLevelReached.setValidators(
          Validators.required
        );
        this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
          Validators.required
        );
        this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValue(
          null
        );

        break;

      case 2:
        this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
          [Validators.required]
        );

        this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.highSchool.setValidators(
          [Validators.required]
        );

        this.educationalBackgroundDetailsGroup.controls.highSchoolLevelReached.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValidators(
          Validators.required
        );
        this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup
          .get("isAttendedSeniorHigh")
          .valueChanges.subscribe((value) => {
            if (value == true) {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.setValidators(
                [Validators.required]
              );

              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
                Validators.required
              );
            } else {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.clearValidators();
            }
          });

        break;

      case 3:
        this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
          [Validators.required]
        );

        this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.highSchool.setValidators(
          [Validators.required]
        );

        this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup
          .get("isAttendedSeniorHigh")
          .valueChanges.subscribe((value) => {
            if (value == true) {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.setValidators(
                [Validators.required]
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.setValidators(
                Validators.required
              );
            } else {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.clearValidators();
            }
          });

        break;

      case 4:
        this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
          [Validators.required]
        );

        this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.highSchool.setValidators(
          [Validators.required]
        );

        this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup
          .get("isAttendedSeniorHigh")
          .valueChanges.subscribe((value) => {
            if (value == true) {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.setValidators(
                [Validators.required]
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.setValidators(
                Validators.required
              );
            } else {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.clearValidators();
            }
          });

        break;

      case 5:
        this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
          [Validators.required]
        );

        this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup.controls.highSchool.setValidators(
          [Validators.required]
        );

        this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValidators(
          Validators.required
        );

        this.educationalBackgroundDetailsGroup
          .get("isAttendedSeniorHigh")
          .valueChanges.subscribe((value) => {
            if (value == true) {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.setValidators(
                [Validators.required]
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.setValidators(
                Validators.required
              );
            } else {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.clearValidators();
            }
          });

        break;
    }

    this.updateValidatorsEducational();
  }

  clearAllValidatorsEducational() {
    const controls = this.educationalBackgroundDetailsGroup.controls;
    Object.keys(controls).forEach((controlName) => {
      controls[controlName].clearValidators();
      controls[controlName].updateValueAndValidity();
    });
  }

  updateValidatorsEducational() {
    const controls = this.educationalBackgroundDetailsGroup.controls;
    Object.keys(controls).forEach((controlName) => {
      controls[controlName].updateValueAndValidity();
    });
  }

  changedID() {
    this.identificationDetailsGroup.controls.dropdown.valueChanges.subscribe(
      (value) => {

        this.identificationDetailsGroup.get("pattern").setValue("");
        this.selectedPhotoName = null;
        this.selectedFileFront = null;
        this.selectedIDBack = null;
        this.selectedID = null;
      }
    );
  }

  private _filterReligion(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.religions.filter((religion) =>
      religion.name.toLowerCase().includes(filterValue)
    );
  }

  private _filterCitizenship(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.allCitizenships.filter((citizenship) =>
      citizenship.name.toLowerCase().includes(filterValue)
    );
  }
  // Present Addres

  onRegionChanged(e) {
    this.addressService.getProvinces(e.value).subscribe((response) => {
      this.provinces = response;
    });
  }

  onProvinceChanged(e) {
    this.addressService
      .getMunicipalitiesCities(e.value)
      .subscribe((response) => {
        this.citiesMunicipalities = response;
      });
  }

  // Permanent Address

  onRegionChangedPermanent(e) {
    this.addressService.getProvinces(e.value).subscribe((response) => {
      this.provincesPermanent = response;
    });
  }

  onProvinceChangedPermanent(e) {
    this.addressService
      .getMunicipalitiesCities(e.value)
      .subscribe((response) => {
        this.citiesMunicipalitiesPermanent = response;
      });
  }

  // Validate citizenship
  validateCitizenship(control: AbstractControl) {
    const selectedCitizenship = control.value;
    const allCitizenships = this.citizenshipService.getAllCitizenships();
    const found = allCitizenships.find(
      (citizenship) => citizenship.name === selectedCitizenship
    );
    if (found || selectedCitizenship === "") {
      return null;
    } else {
      return { invalidCitizenship: true };
    }
  }

  // Validate Religion
  validateReligion(control: AbstractControl) {
    const selectedReligion = control.value;
    const allCitizenships = this.religions;
    const found = allCitizenships.find(
      (citizenship) => citizenship.name === selectedReligion
    );
    if (found || selectedReligion === "") {
      return null;
    } else {
      return { invalidReligionn: true };
    }
  }

  validateAge(control) {
    const axios = require("axios");
    const moment = require("moment");

    axios
      .get("http://worldtimeapi.org/api/timezone/Asia/Manila")
      .then((response) => {
        const today = moment(response.data.datetime).startOf("day");
        const birthDate = moment(control.value, "MM/DD/YYYY");
        const ageDiff = today.diff(birthDate, "years", true);

        if (
          ageDiff < 15 ||
          (ageDiff === 15 && today.isBefore(birthDate, "day"))
        ) {
          const errorMessage = "Must be at least 15 years old to work.";
          const errorMessageElement = document.getElementById("error-message");
          if (errorMessageElement) {
            errorMessageElement.innerHTML = errorMessage;
          }
          control.setErrors({ underage: true });
        }

        const errorMessageElement = document.getElementById("error-message");
        if (errorMessageElement) {
          errorMessageElement.innerHTML = ""; // Clear the error message
        }
        return null;
      })
      .catch((error) => {
        const errorMessage = "Error fetching current time";
        const errorMessageElement = document.getElementById("error-message");
        if (errorMessageElement) {
          errorMessageElement.innerHTML = errorMessage;
        }
      });
  }

  // Validate Height Inches
  validateInches(control: FormControl): ValidationErrors | null {
    switch (control.value) {
      default:
        if (Number(control.value) > 11) {
          this.personalDetailsGroup.patchValue({
            heightInches: "",
          });
          return { invalidHeightInches: true };
        }
        break;
    }

    return null;
  }

  openDialog() {
    const diagRef = this.dialog.open(ForgotPasswordComponent);
    diagRef.afterClosed().subscribe((result) => {});
  }

  onImageError(event) {
    event.target.src = "assets/placeholder.png";
  }

  // ngxdropZones
  onSelectIDFront(event) {
    this.selectedFileFront = event.addedFiles[0];

    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = {
        File: this.selectedFileFront,
        FileName: this.selectedFileFront.name,
      };

      this.selectedFileFront = e.target.result;

      this.idPhotoNameFrontDraft = data;
    };

    reader.readAsDataURL(this.selectedFileFront);
  }

  onSelectBackID(event) {
    this.selectedIDBack = event.addedFiles[0];

    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = {
        File: this.selectedIDBack,
        FileName: this.selectedIDBack.name,
      };

      this.selectedIDBack = e.target.result;

      this.idPhotoNameBackDraft = data;
    };

    reader.readAsDataURL(this.selectedIDBack);
  }

  // Passport Photo
  onSelectPhotoName(event) {
    this.selectedPhotoName = event.addedFiles[0];

    const reader = new FileReader();

    // idPhotoNameDraft
    reader.onload = (e: any) => {
      const data = {
        File: this.selectedPhotoName,
        FileName: this.selectedPhotoName.name,
      };

      this.selectedPhotoName = e.target.result;

      this.idPhotoNameDraft = data;
    };

    reader.readAsDataURL(this.selectedPhotoName);
  }

  // Selfie id
  onSelectSelfie(event) {
    this.selectedID = event.addedFiles[0];

    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = {
        File: this.selectedID,
        FileName: this.selectedID.name,
      };

      this.selectedID = e.target.result;

      this.selfieWithIdPhotoNameDraft = data;
    };

    reader.readAsDataURL(this.selectedID);
  }

  // Identification
  updateApplicantIdentification() {
    if (this.selectedIDType != 1) {

      if (!this.selectedFileFront || !this.selectedIDBack || !this.selectedID) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Upload required images",
          showConfirmButton: false,
          showCloseButton: true,
        });
      } else {
        const updateUserData = (
          finalFront: string,
          finalBack: string,
          finalSelfie: string
        ) => {
          const updatedUserData = { ...this.userData };
          updatedUserData.idPhotoName = "";
          updatedUserData.idPhotoNameFront = finalFront;
          updatedUserData.selfieWithIdPhotoName = finalSelfie;
          updatedUserData.idPhotoNameBack = finalBack;
          updatedUserData.idTypeId =
            this.identificationDetailsGroup.value.dropdown;
          updatedUserData.idNumber =
            this.identificationDetailsGroup.value.pattern;
          return updatedUserData;
        };


        this.userService.postFile(this.idPhotoNameFrontDraft).subscribe(
          (response) => {
          },
          (error) => {
            let finalFrontPhoto = error.error.text;
            if (!finalFrontPhoto) {
              finalFrontPhoto = "";
            }
            // localStorage.setItem("finalFront", finalFrontPhoto);
            this.finalFront = finalFrontPhoto;

            this.updatedUserData = updateUserData(
              this.finalFront,
              this.finalBack,
              this.finalSeflfie
            );

            // this.selectedPhotoName = error.error.text;
          }
        );

        // // this.idPhotoNameBackDraft = data

        this.userService.postFile(this.idPhotoNameBackDraft).subscribe(
          (response) => {
          },
          (error) => {
            let finalBack = error.error.text;
            if (!finalBack) {
              finalBack = "";
            }
            // localStorage.setItem("finalBack", finalBack);

            this.finalBack = finalBack;

            this.updatedUserData = updateUserData(
              this.finalFront,
              this.finalBack,
              this.finalSeflfie
            );

            // this.selectedID = error.error.text;
          }
        );

        // // Selfie
        // // selfieWithIdPhotoNameDraft
        this.userService.postFile(this.selfieWithIdPhotoNameDraft).subscribe(
          (response) => {
          },
          (error) => {
            let finalSefie = error.error.text;
            if (!finalSefie) {
              finalSefie = "";
            }
            // localStorage.setItem("finalSelife", finalSefie);

            this.finalSeflfie = finalSefie;

            this.updatedUserData = updateUserData(
              this.finalFront,
              this.finalBack,
              this.finalSeflfie
            );

            this.userService
              .updateApplicantDetails(this.updatedUserData)
              .subscribe((response) => {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Profile successfully updated",
                  showConfirmButton: false,
                  showCloseButton: true,
                }).then(() => {
                  localStorage.setItem(
                    "applicantDetails",
                    JSON.stringify(response)
                  );
                  this.patchValueIdentification();
                  this.isIdentificationDetailsMode = false;
                });
              });
          }
        );
      }
    } else {
      if (!this.selectedPhotoName || !this.selectedID) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Upload required images",
          showConfirmButton: false,
          showCloseButton: true,
        });
      } else {
        const updateUserData = (
          finalPassport: string,
          finalSeflfie: string
        ) => {
          const updatedUserData = { ...this.userData };
          updatedUserData.idPhotoName = finalPassport || "";
          updatedUserData.idPhotoNameFront = "";
          updatedUserData.selfieWithIdPhotoName = finalSeflfie || "";
          updatedUserData.idPhotoNameBack = "";
          updatedUserData.idTypeId =
            this.identificationDetailsGroup.value.dropdown;
          updatedUserData.idNumber =
            this.identificationDetailsGroup.value.pattern;
          return updatedUserData;
        };

        // Submit idPhotoNameDraft
        this.userService.postFile(this.idPhotoNameDraft).subscribe(
          (response) => {
            this.isFinalPassportConverted = true;

          },
          (error) => {
            let finalPassport = error.error.text;
            if (!finalPassport) {
              finalPassport = "";
            }
            // localStorage.setItem("finalPassport", finalPassport);
            this.finalPassport = finalPassport;

            // Update updatedUserData with finalPassport
            this.updatedUserData = updateUserData(
              this.finalPassport,
              this.finalSeflfie
            );

            // this.userService
            // .updateApplicantDetails(this.updatedUserData)
            // .subscribe((response) => {
            //   Swal.fire({
            //     position: "center",
            //     icon: "success",
            //     title: "Profile successfully updated",
            //     showConfirmButton: false,
            //     showCloseButton: true,
            //   }).then(() => {
            //     localStorage.setItem(
            //       "applicantDetails",
            //       JSON.stringify(response)
            //     );
            //     this.patchValueIdentification();
            //     this.isIdentificationDetailsMode = false;
            //   });
            // });
          }
        );

        // Submit selfieWithIdPhotoNameDraft
        this.userService.postFile(this.selfieWithIdPhotoNameDraft).subscribe(
          (response) => {
            this.isFinalSeflieConverted = true;

          },
          (error) => {
            let finalSefie = error.error.text;
            if (!finalSefie) {
              finalSefie = "";
            }
            // localStorage.setItem("finalSelife", finalSefie);
            this.finalSeflfie = finalSefie;

            // Update updatedUserData with finalSeflfie
            this.updatedUserData = updateUserData(
              this.finalPassport,
              this.finalSeflfie
            );

            this.userService
              .updateApplicantDetails(this.updatedUserData)
              .subscribe((response) => {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Profile successfully updated",
                  showConfirmButton: false,
                  showCloseButton: true,
                }).then(() => {
                  localStorage.setItem(
                    "applicantDetails",
                    JSON.stringify(response)
                  );
                  this.patchValueIdentification();
                  this.isIdentificationDetailsMode = false;
                });
              });
          }
        );

        if (this.isFinalPassportConverted && this.isFinalSeflieConverted) {
        }

        // this.userService
        //   .updateApplicantDetails(this.updatedUserData)
        //   .subscribe((response) => {
        //     Swal.fire({
        //       position: "center",
        //       icon: "success",
        //       title: "Profile successfully updated",
        //       showConfirmButton: false,
        //       showCloseButton: true,
        //     }).then(() => {
        //       localStorage.setItem(
        //         "applicantDetails",
        //         JSON.stringify(response)
        //       );
        //       this.patchValueIdentification();
        //       this.isIdentificationDetailsMode = false;
        //     });
        //   });
      }
    }
  }

  patchValueIdentification() {
    this.userService
      .getApplicantDetails(this.userData.id)
      .subscribe((response) => {

        this.identificationDetailsGroup.patchValue({
          pattern: response.idNumber,
        });

        this.selectedIDType = response.idTypeId;

        (this.selectedPhotoName = response.idPhotoName),
          (this.selectedFileFront = response.idPhotoNameFront),
          (this.selectedIDBack = response.idPhotoNameBack),
          (this.selectedID = response.selfieWithIdPhotoName);
      });
  }

  // loadChangesIdentification() {
  //   // this.idNumberText = this.identificationDetailsGroup.value.pattern;
  //   // const matchedType = this.idTypes.find(
  //   //   (type) => type.id === this.identificationDetailsGroup.value.dropdown
  //   // );
  //   // this.idTypeText = matchedType ? matchedType.label : "ID not available";

  //   this.userService.getApplicantDetails(this.userData.id).subscribe({

  //   })
  // }

  cancelIdentificationDetails() {
    this.isIdentificationDetailsMode = true;

    const originalIDType = this.userData?.idTypeId || "";
    const originalPassport = this.userData?.idPhotoName || "";
    const originalFront = this.userData?.idPhotoNameFront || "";
    const originalBack = this.userData?.idPhotoNameBack || "";
    const originalSelfie = this.userData?.selfieWithIdPhotoName || "";

    Swal.fire({
      title:
        "Are you sure you want to cancel? Any unsaved changes will be lost.",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isIdentificationDetailsMode = false;
        this.selectedIDType = originalIDType;
        this.selectedPhotoName = originalPassport;
        this.selectedID = originalSelfie;
        this.selectedFileFront = originalFront;
        this.selectedIDBack = originalBack;
      } else if (result.isDenied) {
        this.isIdentificationDetailsMode = true;
      }
    });
  }

  hideImageIcon() {
    this.showImageIcon = true;
  }

  contactNumberPrefix(control: AbstractControl): ValidationErrors | null {
    let contactNumberValue = control.value;

    // Check if the contactNumberValue already includes the country code prefix
    const countryCodePrefix = "(+63)";
    if (!contactNumberValue.includes(countryCodePrefix)) {
      // Add the countryCodePrefix to the contactNumberValue
      contactNumberValue = countryCodePrefix;
      control.setValue(contactNumberValue); // Set the value with the prefix added
    }

    return null; // Return null if validation passes
  }

  // ID Photo

  restrictInput(event: any) {
    const input = event.target;
    const value = input.value;

    const month = parseInt(value.substr(0, 2));
    const day = parseInt(value.substr(3, 2));

    // Restrict month to 12
    if (month > 12) {
      input.value = "12";
    }

    // Restrict day based on the month
    const maxDaysInMonth = new Date(
      new Date().getFullYear(),
      month,
      0
    ).getDate();
    if (day > maxDaysInMonth) {
      input.value =
        value.substr(0, 3) + maxDaysInMonth.toString().padStart(2, "0");
    }
  }

  maxValueValidator(control: FormControl) {
    const value = control.value;
    if (value && value > 400) {
      return { maxValueExceeded: true };
    }
    return null;
  }

  // Change Password Method
  changePassword() {}

  addItemUndergraduate() {
    if (this.educationalBackgroundDetailsGroup.invalid) {
      const k12Status =
        this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh
          .value;

      if (k12Status == null) {
        this.showMessagek12 = false;

        this.errorMessagek12 = "";
      } else {
        this.showMessagek12 = true;

        this.errorMessagek12 = "Please select one option";
      }

      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please fill all required field",
        showCloseButton: true,
        showConfirmButton: false,
      });
    } else {
      this.clearAllValidatorsEducational();

      this.educationalBackgroundService
        .getEducationalBackground(this.userData.id)
        .subscribe((response) => {
          const data = {
            id: response.id,
            applicantId: this.userData?.id || "",
            highestEducationLevel: this.highesEducationAttainment,
            isStillStudying:
              this.educationalBackgroundDetailsGroup.controls.isStillStudying
                .value,
            isAttendedSeniorHigh:
              this.educationalBackgroundDetailsGroup.controls
                .isAttendedSeniorHigh.value,
            elementarySchool:
              this.educationalBackgroundDetailsGroup.controls?.elementarySchool
                .value || "",
            elementaryLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.elementaryLevelReached.value || "",
            elementaryYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.elementaryYearAttended.value || "",
            highSchool:
              this.educationalBackgroundDetailsGroup.controls?.highSchool
                .value || "",
            highSchoolLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.highSchoolLevelReached.value || "",
            highSchoolYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.highSchoolYearAttended.value || "",
            seniorHighSchool:
              this.educationalBackgroundDetailsGroup.controls?.seniorHighSchool
                .value || "",
            seniorHighSchoolLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolLevelReached.value || "",
            seniorHighSchoolStrands:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolStrands.value || "",
            seniorHighSchoolYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolYearAttended.value || "",
            UndergraduateDegrees: [
              {
                id: response.id,
                school: "",
                course: "",
                fieldOfStudy: "",
                honors: "",
                yearAttended: "",
              },
            ],
            GraduateDegrees: [
              {
                id: response.id,
                school: "",
                program: "",
                major: "",
                fieldOfStudy: "",
                thesisTitle: "",
                adviser: "",
                honors: "",
                yearAttended: "",
              },
            ],
            PostgraduateDegrees: [
              {
                id: response.id,
                school: "",
                program: "",
                major: "",
                dissertationTitle: "",
                fieldOfStudy: "",
                researchInterests: "",
                publications: "",
                adviser: "",
                yearAttended: "",
              },
            ],
          };

          if (
            this.educationalBackgroundDetailsGroup.get("isAttendedSeniorHigh")
              .value == false
          ) {
            data.seniorHighSchool = "";
            data.seniorHighSchoolLevelReached = "";
            data.seniorHighSchoolStrands = "";
            data.seniorHighSchoolYearAttended = "";
          }

          const dialogRef = this.dialog.open(AddItemUndergraduateComponent, {
            data: {
              response: response[0],
              minDateHighSchool:
                this.educationalBackgroundDetailsGroup.controls
                  .highSchoolYearAttended.value,
              minDateSeniorHigh:
                this.educationalBackgroundDetailsGroup.controls
                  .seniorHighSchoolYearAttended.value,
              isAttendedSeniorHigh:
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value,
            },
            disableClose: true,
          });

          dialogRef.afterClosed().subscribe(() => {
            this.getAllUndergraduates();
            // this.tableUndergraduate.renderRows();
          });
        });
    }

    this.updateValidatorsEducational();
  }

  //Get all Undergraduate
  getAllUndergraduates() {
    this.educationalBackgroundService
      .getEducationalBackgroundsMultipleItems(this.userData.id)
      .subscribe((response) => {
        if (Array.isArray(response) && response.length > 0) {
          if (response[0].hasOwnProperty("undergraduateDegrees")) {
            this.dataSourceUndergraduate = response[0].undergraduateDegrees;
          } else {
            this.dataSourceUndergraduate = [];
          }
        } else {
          this.dataSourceUndergraduate = [];
        }
      });
  }

  // delete undegraduate
  deleteItemUndergraduate(selectedItem: UnderGraduate) {

    const undergraduateItemId = selectedItem.id;

    Swal.fire({
      title: "Do you want to delete this item?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        this.educationalBackgroundService
          .deleteUndergraduate(selectedItem.id)
          .subscribe(() => {
            // const index = this.

            const index = this.dataSourceUndergraduate.findIndex(
              (item) => item.id === undergraduateItemId
            );
            if (index !== -1) {
              this.dataSourceUndergraduate.splice(index, 1);
            }

            // Update the data source with the modified array
            this.dataSourceUndergraduate = new MatTableDataSource(
              this.dataSourceUndergraduate
            );

            // Re-render the table
            this.tableUndergraduate.renderRows();
            this.getAllUndergraduates();
          });
      } else if (result.isDenied) {
        return;
      }
    });
  }

  // update Undergraduate
  updateUndergraduate(selectedItem: UnderGraduate) {
    const dialogRef = this.dialog.open(EditUndergraduateComponent, {
      data: {
        selectedItem,
        minDateHighSchool:
          this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended
            .value,
        minDateSeniorHigh:
          this.educationalBackgroundDetailsGroup.controls
            .seniorHighSchoolYearAttended.value,
        isAttendedSeniorHigh:
          this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh
            .value,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getAllUndergraduates();
    });
  }

  // Add Item Graduate
  addItemGraduate() {
    if (this.dataSourceUndergraduate.length == 0) {
      this.showMessagek12 = true;

      const k12Status =
        this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh
          .value;

      if (k12Status == true || false) {
        this.showMessagek12 = false;
      } else {
        this.showMessagek12 = true;

        this.errorMessagek12 = "Please select one option";
      }

      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please add one item for undergraduate studies",
        showCloseButton: false,
        showConfirmButton: false,
      });
    } else {
      this.clearAllValidatorsEducational();

      this.educationalBackgroundService
        .getEducationalBackground(this.userData.id)
        .subscribe((response) => {
          const data = {
            id: response.id,
            applicantId: this.userData?.id || "",
            highestEducationLevel: this.highesEducationAttainment,
            isStillStudying:
              this.educationalBackgroundDetailsGroup.controls.isStillStudying
                .value,
            isAttendedSeniorHigh:
              this.educationalBackgroundDetailsGroup.controls
                .isAttendedSeniorHigh.value,
            elementarySchool:
              this.educationalBackgroundDetailsGroup.controls?.elementarySchool
                .value || "",
            elementaryLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.elementaryLevelReached.value || "",
            elementaryYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.elementaryYearAttended.value || "",
            highSchool:
              this.educationalBackgroundDetailsGroup.controls?.highSchool
                .value || "",
            highSchoolLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.highSchoolLevelReached.value || "",
            highSchoolYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.highSchoolYearAttended.value || "",
            seniorHighSchool:
              this.educationalBackgroundDetailsGroup.controls?.seniorHighSchool
                .value || "",
            seniorHighSchoolLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolLevelReached.value || "",
            seniorHighSchoolStrands:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolStrands.value || "",
            seniorHighSchoolYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolYearAttended.value || "",
            UndergraduateDegrees: [
              {
                id: response.id,
                school: "",
                course: "",
                fieldOfStudy: "",
                honors: "",
                yearAttended: "",
              },
            ],
            GraduateDegrees: [
              {
                id: response.id,
                school: "",
                program: "",
                major: "",
                fieldOfStudy: "",
                thesisTitle: "",
                adviser: "",
                honors: "",
                yearAttended: "",
              },
            ],
            PostgraduateDegrees: [
              {
                id: response.id,
                school: "",
                program: "",
                major: "",
                dissertationTitle: "",
                fieldOfStudy: "",
                researchInterests: "",
                publications: "",
                adviser: "",
                yearAttended: "",
              },
            ],
          };

          if (
            this.educationalBackgroundDetailsGroup.get("isAttendedSeniorHigh")
              .value == false
          ) {
            data.seniorHighSchool = "";
            data.seniorHighSchoolLevelReached = "";
            data.seniorHighSchoolStrands = "";
            data.seniorHighSchoolYearAttended = "";
          }

          const dialogRef = this.dialog.open(AddItemGraduateComponent, {
            data: {
              response: response[0],
              minDateHighSchool:
                this.educationalBackgroundDetailsGroup.controls
                  .highSchoolYearAttended.value,
              minDateSeniorHigh:
                this.educationalBackgroundDetailsGroup.controls
                  .seniorHighSchoolYearAttended.value,
              isAttendedSeniorHigh:
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value,
            },
            disableClose: true,
          });

          dialogRef.afterClosed().subscribe(() => {
            this.getAllGraduates();
          });
        });
    }
  }

  // Get all graduate
  getAllGraduates() {
    this.educationalBackgroundService
      .getEducationalBackgroundsMultipleItems(this.userData.id)
      .subscribe((response) => {
        if (Array.isArray(response) && response.length > 0) {
          if (response[0].hasOwnProperty("graduateDegrees")) {
            this.dataSourceGraduate = response[0].graduateDegrees;
          } else {
            this.dataSourceGraduate = [];
          }
        } else {
          this.dataSourceGraduate = [];
        }
      });
  }

  // Update Graduate
  updateGraduate(selectedItem: Graduate) {
    const diaglogRef = this.dialog.open(EditGraduateComponent, {
      data: {
        selectedItem,
        minDateHighSchool:
          this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended
            .value,
        minDateSeniorHigh:
          this.educationalBackgroundDetailsGroup.controls
            .seniorHighSchoolYearAttended.value,
        isAttendedSeniorHigh:
          this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh
            .value,
      },
      disableClose: true,
    });

    diaglogRef.afterClosed().subscribe(() => {
      this.getAllGraduates();
    });
  }

  // Delete Graduate
  deleteItemGraduate(selectedItem: Graduate) {
    const graduateItemId = selectedItem.id;

    Swal.fire({
      title: "Do you want to delete this item?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.educationalBackgroundService
          .deleteGraduateStudies(graduateItemId)
          .subscribe((response) => {
            // ...

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Item Deleted",
              showConfirmButton: false,
              showCloseButton: true,
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.close) {
                // Remove the deleted item from the dataSourceTechnicalTrainings array
                const index = this.dataSourceGraduate.findIndex(
                  (item) => item.id === graduateItemId
                );
                if (index !== -1) {
                  this.dataSourceGraduate.splice(index, 1);
                }

                // Update the data source with the modified array
                this.dataSourceGraduate = new MatTableDataSource(
                  this.dataSourceGraduate
                );

                // Re-render the table
                this.tableGraduate.renderRows();
                this.getAllGraduates();
              }
            });
          });
      } else if (result.isDenied) {
        return;
      }
    });
  }

  // Add Post Graduate
  addItemPostGraduate() {
    if (this.dataSourceGraduate.length == 0) {
      this.showMessagek12 = true;

      const k12Status =
        this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh
          .value;

      if (k12Status == true || false) {
        this.showMessagek12 = false;
      } else {
        this.showMessagek12 = true;

        this.errorMessagek12 = "Please select one option";
      }

      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please add one item for graduate studies",
        showCloseButton: false,
        showConfirmButton: false,
      });
    } else {
      this.clearAllValidatorsEducational();

      this.educationalBackgroundService
        .getEducationalBackground(this.userData.id)
        .subscribe((response) => {
          const data = {
            id: response.id,
            applicantId: this.userData?.id || "",
            highestEducationLevel: this.highesEducationAttainment,
            isStillStudying:
              this.educationalBackgroundDetailsGroup.controls.isStillStudying
                .value,
            isAttendedSeniorHigh:
              this.educationalBackgroundDetailsGroup.controls
                .isAttendedSeniorHigh.value,
            elementarySchool:
              this.educationalBackgroundDetailsGroup.controls?.elementarySchool
                .value || "",
            elementaryLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.elementaryLevelReached.value || "",
            elementaryYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.elementaryYearAttended.value || "",
            highSchool:
              this.educationalBackgroundDetailsGroup.controls?.highSchool
                .value || "",
            highSchoolLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.highSchoolLevelReached.value || "",
            highSchoolYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.highSchoolYearAttended.value || "",
            seniorHighSchool:
              this.educationalBackgroundDetailsGroup.controls?.seniorHighSchool
                .value || "",
            seniorHighSchoolLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolLevelReached.value || "",
            seniorHighSchoolStrands:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolStrands.value || "",
            seniorHighSchoolYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolYearAttended.value || "",
            UndergraduateDegrees: [
              {
                id: response.id,
                school: "",
                course: "",
                fieldOfStudy: "",
                honors: "",
                yearAttended: "",
              },
            ],
            GraduateDegrees: [
              {
                id: response.id,
                school: "",
                program: "",
                major: "",
                fieldOfStudy: "",
                thesisTitle: "",
                adviser: "",
                honors: "",
                yearAttended: "",
              },
            ],
            PostgraduateDegrees: [
              {
                id: response.id,
                school: "",
                program: "",
                major: "",
                dissertationTitle: "",
                fieldOfStudy: "",
                researchInterests: "",
                publications: "",
                adviser: "",
                yearAttended: "",
              },
            ],
          };

          if (
            this.educationalBackgroundDetailsGroup.get("isAttendedSeniorHigh")
              .value == false
          ) {
            data.seniorHighSchool = "";
            data.seniorHighSchoolLevelReached = "";
            data.seniorHighSchoolStrands = "";
            data.seniorHighSchoolYearAttended = "";
          }

          const dialogRef = this.dialog.open(AddItemPostGraduateComponent, {
            data: {
              response: response[0],
              minDateHighSchool:
                this.educationalBackgroundDetailsGroup.controls
                  .highSchoolYearAttended.value,
              minDateSeniorHigh:
                this.educationalBackgroundDetailsGroup.controls
                  .seniorHighSchoolYearAttended.value,
              isAttendedSeniorHigh:
                this.educationalBackgroundDetailsGroup.controls
                  .isAttendedSeniorHigh.value,
            },
            disableClose: true,
          });

          dialogRef.afterClosed().subscribe(() => {
            this.getAllPostGraduates();
          });
        });
    }
  }

  // Get all graduate
  getAllPostGraduates() {
    this.educationalBackgroundService
      .getEducationalBackgroundsMultipleItems(this.userData.id)
      .subscribe((response) => {

        if (Array.isArray(response) && response.length > 0) {
          if (response[0].hasOwnProperty("postgraduateDegrees")) {
            this.dataSourcePostGraduate = response[0].postgraduateDegrees;
          } else {
            this.dataSourcePostGraduate = [];
          }
        } else {
          this.dataSourcePostGraduate = [];
        }
      });
  }

  // Edit Post Graudate
  updatePostGraduate(selectedItem: PostGraduate) {
    const diaglogRef = this.dialog.open(EditPostGraduateComponent, {
      data: {
        selectedItem,
        minDateHighSchool:
          this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended
            .value,
        minDateSeniorHigh:
          this.educationalBackgroundDetailsGroup.controls
            .seniorHighSchoolYearAttended.value,
        isAttendedSeniorHigh:
          this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh
            .value,
      },
      disableClose: true,
    });

    diaglogRef.afterClosed().subscribe(() => {
      this.getAllPostGraduates();
    });
  }

  // Delete Post Graduate
  deletePostItemGraduate(selectedItem: PostGraduate) {
    const postGraduateItemId = selectedItem.id;

    Swal.fire({
      title: "Do you want to delete this item?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.educationalBackgroundService
          .deletePostGraduateStudies(postGraduateItemId)
          .subscribe((response) => {
            // ...

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Item Deleted",
              showConfirmButton: false,
              showCloseButton: true,
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.close) {
                // Remove the deleted item from the dataSourceTechnicalTrainings array
                const index = this.dataSourcePostGraduate.findIndex(
                  (item) => item.id === postGraduateItemId
                );
                if (index !== -1) {
                  this.dataSourcePostGraduate.splice(index, 1);
                }

                // Update the data source with the modified array
                this.dataSourcePostGraduate = new MatTableDataSource(
                  this.dataSourcePostGraduate
                );

                // Re-render the table
                this.tablePostGraduate.renderRows();
              }
            });
          });
      } else if (result.isDenied) {
        return;
      }
    });
  }

  // Get all trainings
  getAllTrainings() {
    this.technicalTrainingService
      .getTechnicalTraining(this.userData.id)
      .subscribe((response) => {
        this.dataSourceTechnicalTrainings = response;
      });
  }

  // Add training technical
  addItemTechnical() {
    const dialogRef = this.dialog.open(AddTrainingComponent);
    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result) => {
      // Call method to display table

      this.getAllTrainings();
    });
  }

  // Update training
  updateTechnical(selectedItem: TechnicalTraining) {
    const dialogRef = this.dialog.open(EditTechnicalTrainingComponent, {
      data: { selectedItem },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getAllTrainings();
    });
  }

  // Delete training
  deleteItemTechnical(selectedItem: TechnicalTraining) {
    const technicalTrainingItemId = selectedItem.id;

    Swal.fire({
      title: "Do you want to delete this item?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.technicalTrainingService
          .deleteTechnicalTraining(technicalTrainingItemId)
          .subscribe((response) => {
            // ...

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Item Deleted",
              showConfirmButton: false,
              showCloseButton: true,
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.close) {
                // Remove the deleted item from the dataSourceTechnicalTrainings array
                const index = this.dataSourceTechnicalTrainings.findIndex(
                  (item) => item.id === technicalTrainingItemId
                );
                if (index !== -1) {
                  this.dataSourceTechnicalTrainings.splice(index, 1);
                }

                // Update the data source with the modified array
                this.dataSourceTechnicalTrainings = new MatTableDataSource(
                  this.dataSourceTechnicalTrainings
                );

                // Re-render the table
                this.tabletechnical.renderRows();
              }
            });
          });
      } else if (result.isDenied) {
        return;
      }
    });
  }

  // Add Item Eligibility
  addItemLicense() {
    const dialogRef = this.dialog.open(AddLicenseComponent);

    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result) => {
      this.getAllLicenses();
    });
  }

  // Get all eligibilityupdateApplicantIdentification
  getAllLicenses() {
    this.licenseService.getLicenses(this.userData.id).subscribe((response) => {
      this.dataSoruceEligibilityProfessioalLicense = response;
    });
  }

  updateItemLicense(selectedItem: EligibilityProfessionalLicense) {
    const diaglogRef = this.dialog.open(EditLicenseComponent, {
      data: { selectedItem },
      disableClose: true,
    });

    diaglogRef.afterClosed().subscribe(() => {
      this.getAllLicenses();
    });
  }

  deleteItemLicense(selectedItem: EligibilityProfessionalLicense) {
    const licenseId = selectedItem.id;

    Swal.fire({
      title: "Do you want to delete this item",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.licenseService.deleteLicense(licenseId).subscribe((response) => {

          Swal.fire({
            position: "center",
            icon: "success",
            title: "Item Deleted",
            showConfirmButton: false,
            showCloseButton: true,
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.close) {
              // Remove the deleted item from the dataSourceTechnicalTrainings array
              const index =
                this.dataSoruceEligibilityProfessioalLicense.findIndex(
                  (item) => item.id === licenseId
                );
              if (index !== -1) {
                this.dataSoruceEligibilityProfessioalLicense.splice(index, 1);
              }

              // Update the data source with the modified array
              this.dataSoruceEligibilityProfessioalLicense =
                new MatTableDataSource(
                  this.dataSoruceEligibilityProfessioalLicense
                );

              // Re-render the table
              this.tableEligibilityLicense.renderRows();
            }
          });
        });
      } else if (result.isDenied) {
      }
    });
  }

  // Get all Work Expercience
  getAllWorkHistory() {
    this.workHistoryService
      .getWorkExpercience(this.userData.id)
      .subscribe((response) => {
        this.dataSourceWorkExperience = response.map((item) => {
          const formattedItem = { ...item };
          formattedItem.startOfContractDate = this.formatDate(
            item.startOfContractDate
          );
          formattedItem.endOfContractData = this.formatDate(
            item.endOfContractData
          );
          // Format other date fields if necessary
          return formattedItem;
        });
        //  this.dataSoruceWorkExpercience = response
      });
  }

  updateWorkExpercience(selectedItem: WorkExpercience) {
    const dialogRef = this.dialog.open(EditWorkExpercienceComponent, {
      data: { selectedItem },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getAllWorkHistory();
    });
  }

  // Delete Item Work Expercience
  deleteItemWorkExpercience(selectedItem: WorkExpercience) {
    const workExpercienceItemId = selectedItem.id;

    Swal.fire({
      title: "Do you want to delete item?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.workHistoryService
          .deleteWorkExpercience(workExpercienceItemId)
          .subscribe((response) => {

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Item Deleted",
              showConfirmButton: false,
              showCloseButton: true,
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.close) {
                // Remove the deleted item from the dataSourceTechnicalTrainings array
                const index = this.dataSourceWorkExperience.findIndex(
                  (item) => item.id === workExpercienceItemId
                );
                if (index !== -1) {
                  this.dataSourceWorkExperience.splice(index, 1);
                }

                // Update the data source with the modified array
                this.dataSourceTechnicalTrainings = new MatTableDataSource(
                  this.dataSourceTechnicalTrainings
                );

                // Re-render the table
                this.tableWorkHistory.renderRows();
              }
            });
          });
      } else if (result.isDenied) {
        return;
      }
    });
  }

  // Patch Personal Data
  patchValuePersonalDetails() {
    this.personalDetailsGroup.patchValue({
      firstName: this.userData?.firstName || "",
      middleName: this.userData?.middleName || "",
      lastName: this.userData?.lastName || "",
      suffix: this.userData?.suffixName || "",
      heightFt: this.userData?.heightFt || "",
      heightInches: this.userData?.heightInches || "",
      weight: this.userData?.weight || "",
      civilStatus: this.userData?.civilStatus || "",
      citizenship: this.userData?.citizenship || "",
      gender: this.userData?.gender || "",
      religion: this.userData?.religion || "",
      birthDate: this.userData?.birthDate
        ? new Date(this.userData.birthDate).toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          })
        : null,
      birthPlace: this.userData?.birthPlace || "",
      tin: this.userData?.tin || "",
      contactNumber: this.userData?.contactNumber || "",
    });

    if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = [
        "Visual",
        "Speech",
        "Psychosocial",
        "Hearing",
        "Physical",
      ];
      // four item combination
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Psychosocial", "Hearing"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isPhysicallyDisabled
    ) {
      this.selectedDisability = [
        "Visual",
        "Speech",
        "Psychosocial",
        "Physical",
      ];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Hearing", "Physical"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled
    ) {
      this.selectedDisability = [
        "Visual",
        "Psychosocial",
        "Hearing",
        "Physical",
      ];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = [
        "Speech",
        "Psychosocial",
        "Hearing",
        "Physical",
      ];
      //  three item combination
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Psychosocial"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Hearing"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Physical"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Psychosocial", "Hearing"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPsychosocialDisabled &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Psychosocial", "Physical"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Hearing", "Physical"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Psychosocial", "Hearing"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Psychosocial", "Physical"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Hearing", "Physical"];
    } else if (
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Psychosocial", "Hearing", "Physical"];
      // two item combination
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPsychosocialDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Psychosocial"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Hearing"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Physical"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Psychosocial"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Hearing"];
    } else if (
      this.userData.isSpeechDisabled &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Physical"];
    } else if (
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Psychosocial", "Hearing"];
    } else if (
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Psychosocial", "Physical"];
    } else if (
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Hearing", "Physical"];
    } else if (this.userData.isVisuallyDisabled == true) {
      this.selectedDisability = ["Visual"];
    } else if (this.userData.isSpeechDisabled == true) {
      this.selectedDisability = ["Speech"];
    } else if (this.userData.isPsychosocialDisabled == true) {
      this.selectedDisability = ["Psychosocial"];
    } else if (this.userData.isHearingDisabled == true) {
      this.selectedDisability = ["Hearing"];
    } else if (this.userData.isPhysicallyDisabled == true) {
      this.selectedDisability = ["Physical"];
    } else {
      this.selectedDisability = ["No Disability"];
    }
  }

  // Patch Value Address
  patchValueAddressDetails() {
    this.addressDetailsGroup.patchValue({
      presentStreetName: this.userData?.presentStreetName || "",
      permanentBarangay: this.userData?.permanentBarangay || "",
      permanentStreetName: this.userData?.permanentStreetName || "",
      presentBarangay: this.userData?.presentBarangay || "",
      isAddressPresentEqualToPermanent:
        this.userData?.isAddressPresentEqualToPermanent || "",
    });

    this.permanentAddressStatus =
      this.userData?.isAddressPresentEqualToPermanent;

    this.selectedRegion = this.userData.presentRegionId;
    this.selectedProvince = this.userData.presentProvinceId;
    this.selectedCityMunicipality = this.userData.presentCityId;
    this.selectedBarangayBaguio = this.userData.presentBarangayId;

    this.addressService.getRegions().subscribe((response) => {
      this.regions = response;
      this.addressService
        .getProvinces(this.selectedRegion)
        .subscribe((response) => {
          this.provinces = response;
        });
      this.addressService
        .getMunicipalitiesCities(this.selectedProvince)
        .subscribe((response) => {
          this.citiesMunicipalities = response;
        });
    });

    this.selectedRegionPermanent = this.userData.permanentRegionId;
    this.selectedProvincePermanent = this.userData.permanentProvinceId;
    this.selectedCityMunicipalityPermanent = this.userData.permanentCityId;
    this.selectedBarangayBaguioPermanent = this.userData.permanentBarangayId;

    this.addressService.getRegions().subscribe((response) => {
      this.regionsPermanent = response;
      this.addressService
        .getProvinces(this.selectedRegionPermanent)
        .subscribe((response) => {
          this.provincesPermanent = response;
        });

      this.addressService
        .getMunicipalitiesCities(this.selectedProvincePermanent)
        .subscribe((response) => {
          this.citiesMunicipalitiesPermanent = response;
        });
    });
  }

  // Patch method Educational
  patchValueEducationalDetails() {
    this.educationalBackgroundService
      .getEducationalBackground(this.userData.id)
      .subscribe((response) => {
        const lastIndex = response.length - 1;

        this.userEducation = response[lastIndex];

        const highestEducation = this.userEducation?.highestEducationLevel;

        switch (highestEducation) {
          case 0:
            this.selectedIsStillStudying = this.userEducation?.isStillStudying;

            this.highesEducationAttainment =
              this.userEducation?.highestEducationLevel;

            break;

          case 1:
            this.selectedIsStillStudying = this.userEducation?.isStillStudying;

            this.highesEducationAttainment =
              this.userEducation?.highestEducationLevel;
            this.educationalBackgroundDetailsGroup.patchValue({
              elementarySchool: this.userEducation?.elementarySchool || "",
              elementaryLevelReached:
                this.userEducation?.elementaryLevelReached || "",
              elementaryYearAttended:
                this.userEducation?.elementaryYearAttended || "",
            });

            this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
              [Validators.required, this.notEmptyString]
            );
            this.educationalBackgroundDetailsGroup.controls.elementaryLevelReached.setValidators(
              Validators.required
            );
            this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
              Validators.required
            );
            this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValue(
              null
            );

            break;

          case 2:
            this.selectedIsStillStudying = this.userEducation?.isStillStudying;

            this.highesEducationAttainment =
              this.userEducation?.highestEducationLevel;

            this.educationalBackgroundDetailsGroup.patchValue({
              elementarySchool: this.userEducation?.elementarySchool || "",
              elementaryYearAttended:
                this.userEducation?.elementaryYearAttended || "",
              highSchool: this.userEducation?.highSchool || "",
              highSchoolLevelReached:
                this.userEducation?.highSchoolLevelReached || "",
              highSchoolYearAttended:
                this.userEducation?.highSchoolYearAttended || "",
              isAttendedSeniorHigh: this.userEducation.isAttendedSeniorHigh,
              seniorHighSchool: this.userEducation?.seniorHighSchool || "",
              seniorHighSchoolLevelReached:
                this.userEducation?.seniorHighSchoolLevelReached || "",
              seniorHighSchoolStrands:
                this.userEducation?.seniorHighSchoolStrands || "",
              seniorHighSchoolYearAttended:
                this.userEducation?.seniorHighSchoolYearAttended || "",
            });

            (this.elementaryYear = parseInt(
              this.userEducation?.elementaryYearAttended || ""
            )),
              (this.highSchoolYear = parseInt(
                this.userEducation?.highSchoolYearAttended || ""
              )),
              this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
                Validators.required
              );

            this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
              [Validators.required, this.notEmptyString]
            );

            this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.highSchool.setValidators(
              [Validators.required, this.notEmptyString]
            );

            this.educationalBackgroundDetailsGroup.controls.highSchoolLevelReached.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValidators(
              Validators.required
            );
            this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValidators(
              Validators.required
            );

            if (
              this.educationalBackgroundDetailsGroup.controls
                .isAttendedSeniorHigh.value == true
            ) {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.setValidators(
                [Validators.required, this.notEmptyString]
              );

              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.setValidators(
                Validators.required
              );
            } else {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.clearValidators();
            }

            this.updateValidatorsEducational();

            break;

          case 3:
            this.selectedIsStillStudying = this.userEducation?.isStillStudying;

            this.highesEducationAttainment =
              this.userEducation?.highestEducationLevel;

            this.educationalBackgroundDetailsGroup.patchValue({
              elementarySchool: this.userEducation?.elementarySchool || "",
              elementaryYearAttended:
                this.userEducation?.elementaryYearAttended || "",
              highSchool: this.userEducation?.highSchool || "",
              highSchoolYearAttended:
                this.userEducation?.highSchoolYearAttended || "",
              isAttendedSeniorHigh: this.userEducation.isAttendedSeniorHigh,
              seniorHighSchool: this.userEducation?.seniorHighSchool || "",
              seniorHighSchoolStrands:
                this.userEducation?.seniorHighSchoolStrands || "",
              seniorHighSchoolLevelReached:
                this.userEducation?.seniorHighSchoolLevelReached || "",
              seniorHighSchoolYearAttended:
                this.userEducation?.seniorHighSchoolYearAttended || "",
            });

            this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
              [Validators.required, this.notEmptyString]
            );

            this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.highSchool.setValidators(
              [Validators.required, this.notEmptyString]
            );

            this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValidators(
              Validators.required
            );

            if (
              this.educationalBackgroundDetailsGroup.controls
                .isAttendedSeniorHigh.value == true
            ) {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.setValidators(
                [Validators.required, this.notEmptyString]
              );

              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.setValidators(
                Validators.required
              );
            } else {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.clearValidators();
            }

            this.updateValidatorsEducational();

            break;

          case 4:
            this.selectedIsStillStudying = this.userEducation?.isStillStudying;

            this.highesEducationAttainment =
              this.userEducation?.highestEducationLevel;

            this.educationalBackgroundDetailsGroup.patchValue({
              elementarySchool: this.userEducation?.elementarySchool || "",
              elementaryYearAttended:
                this.userEducation?.elementaryYearAttended || "",
              highSchool: this.userEducation?.highSchool || "",
              highSchoolYearAttended:
                this.userEducation?.highSchoolYearAttended || "",
              isAttendedSeniorHigh: this.userEducation.isAttendedSeniorHigh,
              seniorHighSchool: this.userEducation?.seniorHighSchool || "",
              seniorHighSchoolStrands:
                this.userEducation?.seniorHighSchoolStrands || "",
              seniorHighSchoolLevelReached:
                this.userEducation?.seniorHighSchoolLevelReached || "",
              seniorHighSchoolYearAttended:
                this.userEducation?.seniorHighSchoolYearAttended || "",
            });

            (this.elementaryYear = parseInt(
              this.userEducation?.elementaryYearAttended || ""
            )),
              (this.highSchoolYear = parseInt(
                this.userEducation?.highSchoolYearAttended || ""
              )),
              this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
                Validators.required
              );

            this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
              [Validators.required, this.notEmptyString]
            );

            this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.highSchool.setValidators(
              [Validators.required, this.notEmptyString]
            );

            this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValidators(
              Validators.required
            );

            if (
              this.educationalBackgroundDetailsGroup.controls
                .isAttendedSeniorHigh.value == true
            ) {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.setValidators(
                [Validators.required, this.notEmptyString]
              );

              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.setValidators(
                Validators.required
              );
            } else {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.clearValidators();
            }

            this.updateValidatorsEducational();

            break;

          case 5:
            this.selectedIsStillStudying = this.userEducation?.isStillStudying;

            this.highesEducationAttainment =
              this.userEducation?.highestEducationLevel;

            this.educationalBackgroundDetailsGroup.patchValue({
              elementarySchool: this.userEducation?.elementarySchool || "",
              elementaryYearAttended:
                this.userEducation?.elementaryYearAttended || "",
              highSchool: this.userEducation?.highSchool || "",
              highSchoolYearAttended:
                this.userEducation?.highSchoolYearAttended || "",
              isAttendedSeniorHigh: this.userEducation.isAttendedSeniorHigh,
              seniorHighSchool: this.userEducation?.seniorHighSchool || "",
              seniorHighSchoolStrands:
                this.userEducation?.seniorHighSchoolStrands || "",
              seniorHighSchoolLevelReached:
                this.userEducation?.seniorHighSchoolLevelReached || "",
              seniorHighSchoolYearAttended:
                this.userEducation?.seniorHighSchoolYearAttended || "",
            });

            this.educationalBackgroundDetailsGroup.controls.highestEducationLevel.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.elementarySchool.setValidators(
              [Validators.required, this.notEmptyString]
            );

            this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.highSchool.setValidators(
              [Validators.required, this.notEmptyString]
            );

            this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValidators(
              Validators.required
            );

            this.educationalBackgroundDetailsGroup.controls.isAttendedSeniorHigh.setValidators(
              Validators.required
            );

            if (
              this.educationalBackgroundDetailsGroup.controls
                .isAttendedSeniorHigh.value == true
            ) {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.setValidators(
                [Validators.required, this.notEmptyString]
              );

              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.setValidators(
                Validators.required
              );
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.setValidators(
                Validators.required
              );
            } else {
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchool.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolStrands.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolLevelReached.clearValidators();
              this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.clearValidators();
            }

            this.updateValidatorsEducational();

            break;

          default:
            this.selectedIsStillStudying = null;

            this.highesEducationAttainment = null;

            break;
        }
      });
  }

  formatDate(date: string): string {
    const dateObj = new Date(date);
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${month}/${day}/${year}`;
  }

  // Elementary

  public onYearSelectedElementary(date: Date, datepicker: MatDatepicker<Date>) {
    const normalizedYear = date.getFullYear();
    this.educationalBackgroundDetailsGroup.controls.elementaryYearAttended.setValue(
      new Date(normalizedYear, 12, 0)
    );
    datepicker.close();
  }

  // Secondary

  public onYearSelectedSecondary(date: Date, datepicker: MatDatepicker<Date>) {
    const normalizedYear = date.getFullYear();
    this.educationalBackgroundDetailsGroup.controls.highSchoolYearAttended.setValue(
      new Date(normalizedYear, 12, 0)
    );
    datepicker.close();
  }

  // k-12

  public onYearSelectedK12(date: Date, datepicker: MatDatepicker<Date>) {
    const normalizedYear = date.getFullYear();
    this.educationalBackgroundDetailsGroup.controls.seniorHighSchoolYearAttended.setValue(
      new Date(normalizedYear, 12, 0)
    );
    datepicker.close();
  }

  onSelectionChange(event: any) {
  }

  disableOption(optionValue: string): boolean {
    const selectedValues = this.selectedDisability || [];
    const isNASelected = selectedValues.includes("No Disability");

    if (
      ["Visual", "Speech", "Psychosocial", "Hearing", "Physical"].some(
        (option) => selectedValues.includes(option)
      )
    ) {
      return optionValue === "No Disability";
    }

    return isNASelected && optionValue !== "No Disability";
  }

  // Edit Mode Personal
  editModePersonalView() {
    this.patchValuePersonalDetails();

    this.isPersonalDetailsEditMode = !this.isPersonalDetailsEditMode;

    this.disableNavigation = true;
  }

  // Update Applicant Personal Details
  updatePersonalDetails() {
    if (this.personalDetailsGroup.invalid) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please fill all required fields",
        showCloseButton: true,
        showConfirmButton: false,
      });
    } else {
      const updatedUserData = { ...this.userData };

      (updatedUserData.firstName =
        this.personalDetailsGroup.controls?.firstName.value || ""),
        (updatedUserData.middleName =
          this.personalDetailsGroup.controls?.middleName.value || ""),
        (updatedUserData.lastName =
          this.personalDetailsGroup.controls?.lastName.value || ""),
        (updatedUserData.suffixName =
          this.personalDetailsGroup.controls?.suffix.value || ""),
        (updatedUserData.heightFt =
          this.personalDetailsGroup.controls?.heightFt.value || ""),
        (updatedUserData.heightInches =
          this.personalDetailsGroup.controls?.heightInches.value || ""),
        (updatedUserData.weight =
          this.personalDetailsGroup.controls.weight?.value || ""),
        (updatedUserData.civilStatus =
          this.personalDetailsGroup.controls?.civilStatus.value || ""),
        (updatedUserData.citizenship =
          this.personalDetailsGroup.controls?.citizenship.value || ""),
        (updatedUserData.gender =
          this.personalDetailsGroup.controls?.gender.value || ""),
        (updatedUserData.religion =
          this.personalDetailsGroup.controls?.religion.value || ""),
        (updatedUserData.othersReligion =
          this.personalDetailsGroup.controls?.othersReligion.value),
        (updatedUserData.birthdate =
          this.personalDetailsGroup.controls?.birthDate.value || ""),
        (updatedUserData.birthPlace =
          this.personalDetailsGroup.controls?.birthPlace.value || ""),
        (updatedUserData.isVisuallyDisabled =
          this.selectedDisability?.includes("Visual") || false),
        (updatedUserData.isSpeechDisabled =
          this.selectedDisability?.includes("Speech") || false),
        (updatedUserData.isPsychosocialDisabled =
          this.selectedDisability?.includes("Psychosocial") || false),
        (updatedUserData.isHearingDisabled =
          this.selectedDisability?.includes("Hearing") || false),
        (updatedUserData.isPhysicallyDisabled =
          this.selectedDisability?.includes("Physical") || false),
        (updatedUserData.tin =
          this.personalDetailsGroup.controls?.tin.value || ""),
        (updatedUserData.contactNumber =
          this.personalDetailsGroup.controls?.contactNumber.value || ""),
        this.userService
          .updateApplicantDetails(updatedUserData)
          .subscribe((response) => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Details updated",
              showCloseButton: true,
              showConfirmButton: false,
            }).then(() => {
              localStorage.setItem(
                "applicantDetails",
                JSON.stringify(response)
              );

              this.isPersonalDetailsEditMode = !this.isPersonalDetailsEditMode;

              this.disableNavigation = false;

              this.viewPersonalDetailsGroup.patchValue({
                firstName: response.firstName,
                middleName: response.middleName,
                lastName: response.lastName,
                suffix: response.suffixName,
                heightFt: response.heightFt,
                heightInches: response.heightInches,
                weight: response.weight,
                civilStatus: response.civilStatus,
                citizenship: response.citizenship,
                gender: response.gender,
                religion: response.religion,
                birthDate: response.birthDate
                  ? new Date(response.birthDate).toLocaleDateString("en-US", {
                      month: "2-digit",
                      day: "2-digit",
                      year: "numeric",
                    })
                  : null,
                birthPlace: response.birthPlace,
                tin: response.tin,
                contactNumber: response.contactNumber,
              });

              if (
                response.isVisuallyDisabled == true &&
                response.isSpeechDisabled == true &&
                response.isPsychosocialDisabled == true &&
                response.isHearingDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = [
                  "Visual",
                  "Speech",
                  "Psychosocial",
                  "Hearing",
                  "Physical",
                ];
                // four item combination
              } else if (
                response.isVisuallyDisabled == true &&
                response.isSpeechDisabled == true &&
                response.isPsychosocialDisabled == true &&
                response.isHearingDisabled == true
              ) {
                this.selectedDisability = [
                  "Visual",
                  "Speech",
                  "Psychosocial",
                  "Hearing",
                ];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isSpeechDisabled == true &&
                response.isPsychosocialDisabled == true &&
                response.isPhysicallyDisabled
              ) {
                this.selectedDisability = [
                  "Visual",
                  "Speech",
                  "Psychosocial",
                  "Physical",
                ];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isSpeechDisabled == true &&
                response.isHearingDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = [
                  "Visual",
                  "Speech",
                  "Hearing",
                  "Physical",
                ];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isPsychosocialDisabled == true &&
                response.isHearingDisabled == true &&
                response.isPhysicallyDisabled
              ) {
                this.selectedDisability = [
                  "Visual",
                  "Psychosocial",
                  "Hearing",
                  "Physical",
                ];
              } else if (
                response.isSpeechDisabled == true &&
                response.isPsychosocialDisabled == true &&
                response.isHearingDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = [
                  "Speech",
                  "Psychosocial",
                  "Hearing",
                  "Physical",
                ];
                //  three item combination
              } else if (
                response.isVisuallyDisabled == true &&
                response.isSpeechDisabled == true &&
                response.isPsychosocialDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Speech", "Psychosocial"];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isSpeechDisabled == true &&
                response.isHearingDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Speech", "Hearing"];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isSpeechDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Speech", "Physical"];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isPsychosocialDisabled == true &&
                response.isHearingDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Psychosocial", "Hearing"];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isPsychosocialDisabled &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = [
                  "Visual",
                  "Psychosocial",
                  "Physical",
                ];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isHearingDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Hearing", "Physical"];
              } else if (
                response.isSpeechDisabled == true &&
                response.isPsychosocialDisabled == true &&
                response.isHearingDisabled == true
              ) {
                this.selectedDisability = ["Speech", "Psychosocial", "Hearing"];
              } else if (
                response.isSpeechDisabled == true &&
                response.isPsychosocialDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = [
                  "Speech",
                  "Psychosocial",
                  "Physical",
                ];
              } else if (
                response.isSpeechDisabled == true &&
                response.isHearingDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = ["Speech", "Hearing", "Physical"];
              } else if (
                response.isPsychosocialDisabled == true &&
                response.isHearingDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = [
                  "Psychosocial",
                  "Hearing",
                  "Physical",
                ];
                // two item combination
              } else if (
                response.isVisuallyDisabled == true &&
                response.isSpeechDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Speech"];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isPsychosocialDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Psychosocial"];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isHearingDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Hearing"];
              } else if (
                response.isVisuallyDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = ["Visual", "Physical"];
              } else if (
                response.isSpeechDisabled == true &&
                response.isPsychosocialDisabled == true
              ) {
                this.selectedDisability = ["Speech", "Psychosocial"];
              } else if (
                response.isSpeechDisabled == true &&
                response.isHearingDisabled == true
              ) {
                this.selectedDisability = ["Speech", "Hearing"];
              } else if (
                response.isSpeechDisabled &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = ["Speech", "Physical"];
              } else if (
                response.isPsychosocialDisabled == true &&
                response.isHearingDisabled == true
              ) {
                this.selectedDisability = ["Psychosocial", "Hearing"];
              } else if (
                response.isPsychosocialDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = ["Psychosocial", "Physical"];
              } else if (
                response.isHearingDisabled == true &&
                response.isPhysicallyDisabled == true
              ) {
                this.selectedDisability = ["Hearing", "Physical"];
              } else if (response.isVisuallyDisabled == true) {
                this.selectedDisability = ["Visual"];
              } else if (response.isSpeechDisabled == true) {
                this.selectedDisability = ["Speech"];
              } else if (response.isPsychosocialDisabled == true) {
                this.selectedDisability = ["Psychosocial"];
              } else if (response.isHearingDisabled == true) {
                this.selectedDisability = ["Hearing"];
              } else if (response.isPhysicallyDisabled == true) {
                this.selectedDisability = ["Physical"];
              } else {
                this.selectedDisability = ["No Disability"];
              }
            });
          });
    }
  }

  // Cancel Edit Mode Personal
  cancelEditModePersonalDetails() {
    this.patchValueViewPersonalDetails();

    this.isPersonalDetailsEditMode = !this.isPersonalDetailsEditMode;
    this.disableNavigation = false;
  }

  // Patch Value View Personal
  patchValueViewPersonalDetails() {
    this.viewPersonalDetailsGroup.patchValue({
      firstName: this.userData?.firstName || "",
      middleName: this.userData?.middleName || "",
      lastName: this.userData?.lastName || "",
      suffix: this.userData?.suffixName || "",
      heightFt: this.userData?.heightFt || "",
      heightInches: this.userData?.heightInches || "",
      weight: this.userData?.weight || "",
      civilStatus: this.userData?.civilStatus || "",
      citizenship: this.userData?.citizenship || "",
      gender: this.userData?.gender || "",
      religion: this.userData?.religion || "",
      birthDate: this.userData?.birthDate
        ? new Date(this.userData.birthDate).toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          })
        : null,
      birthPlace: this.userData?.birthPlace || "",
      tin: this.userData?.tin || "",
      contactNumber: this.userData?.contactNumber || "",
    });

    if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = [
        "Visual",
        "Speech",
        "Psychosocial",
        "Hearing",
        "Physical",
      ];
      // four item combination
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Psychosocial", "Hearing"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isPhysicallyDisabled
    ) {
      this.selectedDisability = [
        "Visual",
        "Speech",
        "Psychosocial",
        "Physical",
      ];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Hearing", "Physical"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled
    ) {
      this.selectedDisability = [
        "Visual",
        "Psychosocial",
        "Hearing",
        "Physical",
      ];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = [
        "Speech",
        "Psychosocial",
        "Hearing",
        "Physical",
      ];
      //  three item combination
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Psychosocial"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Hearing"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech", "Physical"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Psychosocial", "Hearing"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPsychosocialDisabled &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Psychosocial", "Physical"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Hearing", "Physical"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Psychosocial", "Hearing"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Psychosocial", "Physical"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Hearing", "Physical"];
    } else if (
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Psychosocial", "Hearing", "Physical"];
      // two item combination
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isSpeechDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Speech"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPsychosocialDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Psychosocial"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Hearing"];
    } else if (
      this.userData.isVisuallyDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Visual", "Physical"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isPsychosocialDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Psychosocial"];
    } else if (
      this.userData.isSpeechDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Hearing"];
    } else if (
      this.userData.isSpeechDisabled &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Speech", "Physical"];
    } else if (
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isHearingDisabled == true
    ) {
      this.selectedDisability = ["Psychosocial", "Hearing"];
    } else if (
      this.userData.isPsychosocialDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Psychosocial", "Physical"];
    } else if (
      this.userData.isHearingDisabled == true &&
      this.userData.isPhysicallyDisabled == true
    ) {
      this.selectedDisability = ["Hearing", "Physical"];
    } else if (this.userData.isVisuallyDisabled == true) {
      this.selectedDisability = ["Visual"];
    } else if (this.userData.isSpeechDisabled == true) {
      this.selectedDisability = ["Speech"];
    } else if (this.userData.isPsychosocialDisabled == true) {
      this.selectedDisability = ["Psychosocial"];
    } else if (this.userData.isHearingDisabled == true) {
      this.selectedDisability = ["Hearing"];
    } else if (this.userData.isPhysicallyDisabled == true) {
      this.selectedDisability = ["Physical"];
    } else {
      this.selectedDisability = ["No Disability"];
    }
  }

  // Edit Mode Address
  editModeAddress() {
    this.isAddressDetailsEditMode = !this.isAddressDetailsEditMode;
    this.disableNavigation = true;
  }

  // Update button address details
  updateApplicantAddress() {
    if (this.addressDetailsGroup.invalid) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please fill all required fields",
        showCloseButton: true,
        showConfirmButton: false,
      });
    } else {
      const updatedUserData = { ...this.userData };

      updatedUserData.presentRegionId =
        this.addressDetailsGroup.value.presentRegionId;
      updatedUserData.presentProvinceId =
        this.addressDetailsGroup.value.presentProvinceId;
      updatedUserData.presentCityId =
        this.addressDetailsGroup.value.presentCityId;
      updatedUserData.presentBarangayId =
        this.addressDetailsGroup.value.presentBarangayId;
      updatedUserData.presentBarangay =
        this.addressDetailsGroup.value.presentBarangay;
      updatedUserData.presentStreetName =
        this.addressDetailsGroup.value.presentStreetName;
      updatedUserData.permanentRegionId =
        updatedUserData.isAddressPresentEqualToPermanent =
          this.addressDetailsGroup.value.isAddressPresentEqualToPermanent;
      this.addressDetailsGroup.value.permanentRegionId;
      updatedUserData.permanentProvinceId =
        this.addressDetailsGroup.value.permanentProvinceId;
      updatedUserData.permanentCityId =
        this.addressDetailsGroup.value.permanentCityId;
      updatedUserData.permanentBarangayId =
        this.addressDetailsGroup.value.permanentBarangayId;
      updatedUserData.permanentBarangay =
        this.addressDetailsGroup.value.permanentBarangay;
      updatedUserData.permanentStreetName =
        this.addressDetailsGroup.value.permanentStreetName;

      if (updatedUserData.isAddressPresentEqualToPermanent == 1) {
        updatedUserData.permanentRegionId = updatedUserData.presentRegionId;
        updatedUserData.permanentProvinceId = updatedUserData.presentProvinceId;
        updatedUserData.permanentCityId = updatedUserData.presentCityId;
        updatedUserData.permanentStreetName = updatedUserData.presentStreetName;
        updatedUserData.permanentFloorNumber =
          updatedUserData.presentFloorNumber;
        updatedUserData.permanentUnitNumber = updatedUserData.presentUnitNumber;
        updatedUserData.permanentBarangayId = updatedUserData.presentBarangayId;
        updatedUserData.permanentBarangay = updatedUserData.presentBarangay;
      }

      this.userService
        .updateApplicantDetails(updatedUserData)
        .subscribe((response) => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Details updated",
            showCloseButton: true,
            showConfirmButton: false,
          }).then(() => {

            localStorage.setItem("applicantDetails", JSON.stringify(response));

            this.viewAddressDetailsGroup.patchValue({
              presentRegionId: response.presentRegionId,
              presentProvinceId: response.presentProvinceId,
              presentCityId: response.presentCityId,
              presentBarangayID: response.presentBarangayID,
              presentBarangay: response.presentBarangay,
              presentStreetName: response.presentStreetName,
              isAddressPresentEqualToPermanent:
                response.isAddressPresentEqualToPermanent,
              permanentRegionId: response.permamentRegionId,
              permanentProvinceId: response.permanentProvinceId,
              permanentCityId: response.permanentCityId,
              permanentBarangayID: response.permanentBarangayID,
              permanentBarangay: response.permanentBarangay,
              permanentStreetName: response.permanentStreetName,
            });

            this.disableNavigation = false;

            this.isAddressDetailsEditMode = !this.isAddressDetailsEditMode;
          });
        });
    }
  }

  // Cancel Edit Mode Personal
  cancelEditModeAddresslDetails() {
    this.patchValueAddressDetails();

    this.isAddressDetailsEditMode = !this.isAddressDetailsEditMode;
    this.disableNavigation = false;
  }

  // Patch Value View Address
  patchValueViewAddressDetails() {
    this.viewAddressDetailsGroup.patchValue({
      presentStreetName: this.userData?.presentStreetName || "",
      permanentBarangay: this.userData?.permanentBarangay || "",
      permanentStreetName: this.userData?.permanentStreetName || "",
      presentBarangay: this.userData?.presentBarangay || "",
      isAddressPresentEqualToPermanent:
        this.userData?.isAddressPresentEqualToPermanent || "",
    });

    this.permanentAddressStatus =
      this.userData?.isAddressPresentEqualToPermanent;

    this.selectedRegion = this.userData.presentRegionId;
    this.selectedProvince = this.userData.presentProvinceId;
    this.selectedCityMunicipality = this.userData.presentCityId;
    this.selectedBarangayBaguio = this.userData.presentBarangayId;

    this.addressService.getRegions().subscribe((response) => {
      this.regions = response;
      this.addressService
        .getProvinces(this.selectedRegion)
        .subscribe((response) => {
          this.provinces = response;
        });
      this.addressService
        .getMunicipalitiesCities(this.selectedProvince)
        .subscribe((response) => {
          this.citiesMunicipalities = response;
        });
    });

    this.selectedRegionPermanent = this.userData.permanentRegionId;
    this.selectedProvincePermanent = this.userData.permanentProvinceId;
    this.selectedCityMunicipalityPermanent = this.userData.permanentCityId;
    this.selectedBarangayBaguioPermanent = this.userData.permanentBarangayId;

    this.addressService.getRegions().subscribe((response) => {
      this.regionsPermanent = response;
      this.addressService
        .getProvinces(this.selectedRegionPermanent)
        .subscribe((response) => {
          this.provincesPermanent = response;
        });

      this.addressService
        .getMunicipalitiesCities(this.selectedProvincePermanent)
        .subscribe((response) => {
          this.citiesMunicipalitiesPermanent = response;
        });
    });
  }

  // Edit Educational Background
  editEducationalBackground() {
    this.patchValueEducationalDetails();

    this.isEducationalDetailsEditMode = !this.isEducationalDetailsEditMode;
    this.disableNavigation = true;
  }

  // Update Educational Details
  updateEducationalDetails() {
    if (this.educationalBackgroundDetailsGroup.invalid) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please fill all required field",
        showCloseButton: true,
        showConfirmButton: false,
      });
    } else {
      // const data = {
      //   applicantId: this.userData?.id || "",
      //   highestEducationLevel: this.highesEducationAttainment,
      //   isStillStudying:
      //     this.educationalBackgroundDetailsGroup.controls.isStillStudying.value,
      //   isAttendedSeniorHigh:
      //     this.educationalBackgroundDetailsGroup.controls?.isAttendedSeniorHigh
      //       .value || false,
      //   elementarySchool:
      //     this.educationalBackgroundDetailsGroup.controls?.elementarySchool
      //       .value || "",
      //   elementaryLevelReached:
      //     this.educationalBackgroundDetailsGroup.controls
      //       ?.elementaryLevelReached.value || "",
      //   elementaryYearAttended:
      //     this.educationalBackgroundDetailsGroup.controls
      //       ?.elementaryYearAttended.value || "",
      //   highSchool:
      //     this.educationalBackgroundDetailsGroup.controls?.highSchool.value ||
      //     "",
      //   highSchoolLevelReached:
      //     this.educationalBackgroundDetailsGroup.controls
      //       ?.highSchoolLevelReached.value || "",
      //   highSchoolYearAttended:
      //     this.educationalBackgroundDetailsGroup.controls
      //       ?.highSchoolYearAttended.value || "",
      //   seniorHighSchool:
      //     this.educationalBackgroundDetailsGroup.controls?.seniorHighSchool
      //       .value || "",
      //   seniorHighSchoolLevelReached:
      //     this.educationalBackgroundDetailsGroup.controls
      //       ?.seniorHighSchoolLevelReached.value || "",
      //   seniorHighSchoolStrands:
      //     this.educationalBackgroundDetailsGroup.controls
      //       ?.seniorHighSchoolStrands.value || "",
      //   seniorHighSchoolYearAttended:
      //     this.educationalBackgroundDetailsGroup.controls
      //       ?.seniorHighSchoolYearAttended.value || "",
      // };

      // if (
      //   this.educationalBackgroundDetailsGroup.get("isAttendedSeniorHigh")
      //     .value == false
      // ) {
      //   data.seniorHighSchool = "";
      //   data.seniorHighSchoolLevelReached = "";
      //   data.seniorHighSchoolStrands = "";
      //   data.seniorHighSchoolYearAttended = "";
      // }

      // this.educationalBackgroundService
      //   .addEducationBackground(data)
      //   .subscribe(() => {
      //     Swal.fire({
      //       position: "center",
      //       icon: "success",
      //       title: "Details updated",
      //       showCloseButton: true,
      //       showConfirmButton: false,
      //     }).then(() => {
      //       // this.patchValueEducationalDetails();

      //       this.isEducationalDetailsEditMode =
      //         !this.isEducationalDetailsEditMode;

      //       this.disableNavigation = false;

      //       this.patchValueViewEducationalBackground();
      //     });
      //   });

      this.educationalBackgroundService
        .getEducationalBackground(this.userData.id)
        .subscribe((response) => {


          const data = {
            id: response[0].id,
            applicantId: this.userData?.id || "",
            highestEducationLevel: this.highesEducationAttainment,
            isStillStudying:
              this.educationalBackgroundDetailsGroup.controls.isStillStudying
                .value,
            isAttendedSeniorHigh:
              this.educationalBackgroundDetailsGroup.controls
                ?.isAttendedSeniorHigh.value || false,
            elementarySchool:
              this.educationalBackgroundDetailsGroup.controls?.elementarySchool
                .value || "",
            elementaryLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.elementaryLevelReached.value || "",
            elementaryYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.elementaryYearAttended.value || "",
            highSchool:
              this.educationalBackgroundDetailsGroup.controls?.highSchool
                .value || "",
            highSchoolLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.highSchoolLevelReached.value || "",
            highSchoolYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.highSchoolYearAttended.value || "",
            seniorHighSchool:
              this.educationalBackgroundDetailsGroup.controls?.seniorHighSchool
                .value || "",
            seniorHighSchoolLevelReached:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolLevelReached.value || "",
            seniorHighSchoolStrands:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolStrands.value || "",
            seniorHighSchoolYearAttended:
              this.educationalBackgroundDetailsGroup.controls
                ?.seniorHighSchoolYearAttended.value || "",
            UndergraduateDegrees: [
              {
                id: response[0].id,
                school: "",
                course: "",
                fieldOfStudy: "",
                honors: "",
                yearAttended: "",
              },
            ],
            GraduateDegrees: [
              {
                id: response[0].id,
                school: "",
                program: "",
                major: "",
                fieldOfStudy: "",
                thesisTitle: "",
                adviser: "",
                honors: "",
                yearAttended: "",
              },
            ],
            PostgraduateDegrees: [
              {
                id: response[0].id,
                school: "",
                program: "",
                major: "",
                dissertationTitle: "",
                fieldOfStudy: "",
                researchInterests: "",
                publications: "",
                adviser: "",
                yearAttended: "",
              },
            ],
          };

          if (
            this.educationalBackgroundDetailsGroup.get("isAttendedSeniorHigh")
              .value == false
          ) {
            data.seniorHighSchool = "";
            data.seniorHighSchoolLevelReached = "";
            data.seniorHighSchoolStrands = "";
            data.seniorHighSchoolYearAttended = "";
          }

          this.educationalBackgroundService
            .updateEducationBackground(response[0].id, data)
            .subscribe(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Details updated",
                showCloseButton: true,
                showConfirmButton: false,
              }).then(() => {
                // this.patchValueEducationalDetails();

                this.isEducationalDetailsEditMode =
                  !this.isEducationalDetailsEditMode;

                this.disableNavigation = false;

                this.patchValueViewEducationalBackground();
              });
            });
        });
    }
  }

  cancelEditModeEducationalBackgroundDetails() {
    this.patchValueViewEducationalBackground();

    this.isEducationalDetailsEditMode = !this.isEducationalDetailsEditMode;
    this.disableNavigation = false;
  }

  patchValueViewEducationalBackground() {
    this.educationalBackgroundService
      .getEducationalBackground(this.userData.id)
      .subscribe((response) => {

        this.userEducation = response[0];
        
        this.highesEducationAttainment = this.userEducation.highestEducationLevel

        this.viewEducationalDetailsGroup.patchValue({
          isStillStudying: this.userEducation.isStillStudying,
          elementarySchool: this.userEducation.elementarySchool,
          elementaryLevelReached: this.userEducation.elementaryLevelReached,
          elementaryYearAttended: this.userEducation.elementaryYearAttended,
          highSchool: this.userEducation.highSchool,
          highSchoolLevelReached: this.userEducation.highSchoolLevelReached,
          highSchoolYearAttended: this.userEducation.highSchoolYearAttended,
          isAttendedSeniorHigh: this.userEducation.isAttendedSeniorHigh,
          seniorHighSchool: this.userEducation.seniorHighSchool,
          seniorHighSchoolStrands: this.userEducation.seniorHighSchoolStrands,
          seniorHighSchoolLevelReached:
            this.userEducation.seniorHighSchoolLevelReached,
          seniorHighSchoolYearAttended:
            this.userEducation.seniorHighSchoolYearAttended,
        });
      });
  }

  //Filtered Fruits

  private _filterfrutis(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.otherSkills.filter(
      (fruit) => fruit.toLowerCase().indexOf(filterValue) === 0
    );
  }

  // Select fruit method

  selected(event: MatAutocompleteSelectedEvent): void {
    this.fruits.push(event.option.viewValue);
    this.fruitInput.nativeElement.value = "";
    this.fruitCtrl.setValue(null);
  }

  add(event: MatChipInputEvent): void {
    // Add fruit only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      // Add our fruit
      if ((value || "").trim()) {
        this.fruits.push(value.trim());
      }

      // Reset the input value
      if (input) {
        input.value = "";
      }

      this.fruitCtrl.setValue(null);
    }
  }

  // Add skills method
  addOtherSkills() {
    this.fruits.forEach((fruit) => {
      const data = {
        applicantId: this.userData.id,
        skill: fruit,
      };


      this.skillsWithoutCertificateService
        .addSkills(data)
        .subscribe((response) => {
        });
    });
  }

  remove(fruit: string): void {
    const index = this.fruits.indexOf(fruit);

    this.skillsWithoutCertificateService
      .getSkills(this.userData.id)
      .subscribe((response) => {
        const foundItem = response.find((item) => item.skill === fruit);

        if (foundItem) {
          this.skillsWithoutCertificateService
            .deleteSkills(foundItem.id)
            .subscribe(() => {
              // Remove the item from the fruits array based on its index
              if (index >= 0) {
                this.fruits.splice(index, 1);
              }
            });
        } else {
          // Handle the case when the skill is not found in the response
        }
      });
  }

  getSkills() {
    this.skillsWithoutCertificateService
      .getSkills(this.userData.id)
      .subscribe((response) => {
        response.forEach((e) => {
          this.fruits.push(e.skill);
        });
      });
  }

  notEmptyString(control) {
    const value = control.value;

    if (value === null || value.trim() === "") {
      return { notEmptyString: true };
    }

    return null;
  }
}
